/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LayoutDashboardIndexRouteImport } from './routes/_layout/dashboard/index'
import { Route as LayoutDashboardUsersIndexRouteImport } from './routes/_layout/dashboard/users/index'
import { Route as LayoutDashboardSitesIndexRouteImport } from './routes/_layout/dashboard/sites/index'
import { Route as LayoutDashboardSalesAgentsIndexRouteImport } from './routes/_layout/dashboard/sales-agents/index'
import { Route as LayoutDashboardResellersIndexRouteImport } from './routes/_layout/dashboard/resellers/index'
import { Route as LayoutDashboardOrganizationsIndexRouteImport } from './routes/_layout/dashboard/organizations/index'
import { Route as LayoutDashboardHelpIndexRouteImport } from './routes/_layout/dashboard/help/index'
import { Route as LayoutDashboardHelpAndSupportIndexRouteImport } from './routes/_layout/dashboard/help-and-support/index'
import { Route as LayoutDashboardGeneralIndexRouteImport } from './routes/_layout/dashboard/general/index'
import { Route as LayoutDashboardCommissionsIndexRouteImport } from './routes/_layout/dashboard/commissions/index'
import { Route as LayoutDashboardBlogIndexRouteImport } from './routes/_layout/dashboard/blog/index'
import { Route as LayoutDashboardAccountSettingsIndexRouteImport } from './routes/_layout/dashboard/account-settings/index'
import { Route as LayoutDashboardUsersCreateUserIndexRouteImport } from './routes/_layout/dashboard/users/create-user/index'
import { Route as LayoutDashboardUsersUserIdIndexRouteImport } from './routes/_layout/dashboard/users/$userId/index'
import { Route as LayoutDashboardSitesCreateIndexRouteImport } from './routes/_layout/dashboard/sites/create/index'
import { Route as LayoutDashboardSitesCreateGroupIndexRouteImport } from './routes/_layout/dashboard/sites/create-group/index'
import { Route as LayoutDashboardSitesCreateGroupSiteIndexRouteImport } from './routes/_layout/dashboard/sites/create-group-site/index'
import { Route as LayoutDashboardSitesCreateCollectionIndexRouteImport } from './routes/_layout/dashboard/sites/create-collection/index'
import { Route as LayoutDashboardSitesSiteIdIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/index'
import { Route as LayoutDashboardSalesAgentsCreateIndexRouteImport } from './routes/_layout/dashboard/sales-agents/create/index'
import { Route as LayoutDashboardResellersCreateIndexRouteImport } from './routes/_layout/dashboard/resellers/create/index'
import { Route as LayoutDashboardResellersResellerIdIndexRouteImport } from './routes/_layout/dashboard/resellers/$resellerId/index'
import { Route as LayoutDashboardOrganizationsCreateIndexRouteImport } from './routes/_layout/dashboard/organizations/create/index'
import { Route as LayoutDashboardHelpAndSupportContactFormIndexRouteImport } from './routes/_layout/dashboard/help-and-support/contact-form/index'
import { Route as LayoutDashboardCommissionsPayoutsReportIndexRouteImport } from './routes/_layout/dashboard/commissions/payouts-report/index'
import { Route as LayoutDashboardCommissionsPaymentHistoryIndexRouteImport } from './routes/_layout/dashboard/commissions/payment-history/index'
import { Route as LayoutDashboardCommissionsConfigHistoryIndexRouteImport } from './routes/_layout/dashboard/commissions/config-history/index'
import { Route as LayoutDashboardBlogCreateIndexRouteImport } from './routes/_layout/dashboard/blog/create/index'
import { Route as LayoutDashboardBlogBlogIdIndexRouteImport } from './routes/_layout/dashboard/blog/$blogId/index'
import { Route as LayoutDashboardUsersUserIdEditIndexRouteImport } from './routes/_layout/dashboard/users/$userId/edit/index'
import { Route as LayoutDashboardSitesSiteIdSiteCustomizationIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/site-customization/index'
import { Route as LayoutDashboardSitesSiteIdServiceBlocksIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/service-blocks/index'
import { Route as LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/seasonal-cancellation-policies/index'
import { Route as LayoutDashboardSitesSiteIdRoomsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rooms/index'
import { Route as LayoutDashboardSitesSiteIdRoomBlocksIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/room-blocks/index'
import { Route as LayoutDashboardSitesSiteIdRestrictionsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/restrictions/index'
import { Route as LayoutDashboardSitesSiteIdReservationsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/reservations/index'
import { Route as LayoutDashboardSitesSiteIdInventoriesIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/inventories/index'
import { Route as LayoutDashboardSitesSiteIdIntegrationsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/integrations/index'
import { Route as LayoutDashboardSitesSiteIdEventsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/events/index'
import { Route as LayoutDashboardSitesSiteIdDailyPricingIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/daily-pricing/index'
import { Route as LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/activities-and-products/index'
import { Route as LayoutDashboardSalesAgentsAgentIdEditIndexRouteImport } from './routes/_layout/dashboard/sales-agents/$agentId/edit/index'
import { Route as LayoutDashboardResellersResellerIdEditIndexRouteImport } from './routes/_layout/dashboard/resellers/$resellerId/edit/index'
import { Route as LayoutDashboardOrganizationsOrganizationIdEditIndexRouteImport } from './routes/_layout/dashboard/organizations/$organizationId/edit/index'
import { Route as LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRouteImport } from './routes/_layout/dashboard/help-and-support/quick-answers/update-branding/index'
import { Route as LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRouteImport } from './routes/_layout/dashboard/help-and-support/quick-answers/shift4-guide/index'
import { Route as LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRouteImport } from './routes/_layout/dashboard/help-and-support/quick-answers/quickbook-integration/index'
import { Route as LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRouteImport } from './routes/_layout/dashboard/help-and-support/quick-answers/mews-rates/index'
import { Route as LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRouteImport } from './routes/_layout/dashboard/help-and-support/quick-answers/mews-packages/index'
import { Route as LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRouteImport } from './routes/_layout/dashboard/help-and-support/quick-answers/gtm-guide/index'
import { Route as LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRouteImport } from './routes/_layout/dashboard/help-and-support/quick-answers/ga4-guide/index'
import { Route as LayoutDashboardGroupGroupIdPerformanceIndexRouteImport } from './routes/_layout/dashboard/group/$groupId/performance/index'
import { Route as LayoutDashboardGroupGroupIdEditGroupIndexRouteImport } from './routes/_layout/dashboard/group/$groupId/edit-group/index'
import { Route as LayoutDashboardGroupGroupIdCommissionsIndexRouteImport } from './routes/_layout/dashboard/group/$groupId/commissions/index'
import { Route as LayoutDashboardCollectionCollectionIdEditIndexRouteImport } from './routes/_layout/dashboard/collection/$collectionId/edit/index'
import { Route as LayoutDashboardBlogBlogIdEditIndexRouteImport } from './routes/_layout/dashboard/blog/$blogId/edit/index'
import { Route as LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/site-customization/policies/index'
import { Route as LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/site-customization/emails/index'
import { Route as LayoutDashboardSitesSiteIdRoomsCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rooms/create/index'
import { Route as LayoutDashboardSitesSiteIdRoomsAddOnsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rooms/add-ons/index'
import { Route as LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/room-blocks/create/index'
import { Route as LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/index'
import { Route as LayoutDashboardSitesSiteIdRestrictionsCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/restrictions/create/index'
import { Route as LayoutDashboardSitesSiteIdReservationsWaitlistIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/reservations/waitlist/index'
import { Route as LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/reservations/$purchaseId/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/packages/index'
import { Route as LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/inventories/property-restrictions/index'
import { Route as LayoutDashboardSitesSiteIdEventsCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/events/create/index'
import { Route as LayoutDashboardSitesSiteIdEventsEventIdIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/events/$eventId/index'
import { Route as LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/activities-and-products/create/index'
import { Route as LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rooms/add-ons/create/index'
import { Route as LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rooms/$roomId/edit/index'
import { Route as LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/index'
import { Route as LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/restrictions/$restrictionId/edit/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/create/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/packages/create/index'
import { Route as LayoutDashboardSitesSiteIdEventsEventIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/events/$eventId/edit/index'
import { Route as LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/activities-and-products/$activityId/edit/index'
import { Route as LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/index'
import { Route as LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy/index'
import { Route as LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/index'
import { Route as LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit/index'
import { Route as LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit/index'
import { Route as LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRouteImport } from './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/index'

const ForgotPasswordLazyRouteImport = createFileRoute('/forgot-password')()
const ResetPasswordTokenIndexLazyRouteImport = createFileRoute(
  '/reset-password/$token/',
)()

const ForgotPasswordLazyRoute = ForgotPasswordLazyRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/forgot-password.lazy').then((d) => d.Route),
)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const ResetPasswordTokenIndexLazyRoute =
  ResetPasswordTokenIndexLazyRouteImport.update({
    id: '/reset-password/$token/',
    path: '/reset-password/$token/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/reset-password/$token/index.lazy').then((d) => d.Route),
  )
const LayoutDashboardIndexRoute = LayoutDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => LayoutRoute,
} as any).lazy(() =>
  import('./routes/_layout/dashboard/index.lazy').then((d) => d.Route),
)
const LayoutDashboardUsersIndexRoute =
  LayoutDashboardUsersIndexRouteImport.update({
    id: '/dashboard/users/',
    path: '/dashboard/users/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/users/index.lazy').then((d) => d.Route),
  )
const LayoutDashboardSitesIndexRoute =
  LayoutDashboardSitesIndexRouteImport.update({
    id: '/dashboard/sites/',
    path: '/dashboard/sites/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/sites/index.lazy').then((d) => d.Route),
  )
const LayoutDashboardSalesAgentsIndexRoute =
  LayoutDashboardSalesAgentsIndexRouteImport.update({
    id: '/dashboard/sales-agents/',
    path: '/dashboard/sales-agents/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/sales-agents/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardResellersIndexRoute =
  LayoutDashboardResellersIndexRouteImport.update({
    id: '/dashboard/resellers/',
    path: '/dashboard/resellers/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/resellers/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardOrganizationsIndexRoute =
  LayoutDashboardOrganizationsIndexRouteImport.update({
    id: '/dashboard/organizations/',
    path: '/dashboard/organizations/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/organizations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardHelpIndexRoute =
  LayoutDashboardHelpIndexRouteImport.update({
    id: '/dashboard/help/',
    path: '/dashboard/help/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardHelpAndSupportIndexRoute =
  LayoutDashboardHelpAndSupportIndexRouteImport.update({
    id: '/dashboard/help-and-support/',
    path: '/dashboard/help-and-support/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/help-and-support/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardGeneralIndexRoute =
  LayoutDashboardGeneralIndexRouteImport.update({
    id: '/dashboard/general/',
    path: '/dashboard/general/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardCommissionsIndexRoute =
  LayoutDashboardCommissionsIndexRouteImport.update({
    id: '/dashboard/commissions/',
    path: '/dashboard/commissions/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/commissions/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardBlogIndexRoute =
  LayoutDashboardBlogIndexRouteImport.update({
    id: '/dashboard/blog/',
    path: '/dashboard/blog/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/blog/index.lazy').then((d) => d.Route),
  )
const LayoutDashboardAccountSettingsIndexRoute =
  LayoutDashboardAccountSettingsIndexRouteImport.update({
    id: '/dashboard/account-settings/',
    path: '/dashboard/account-settings/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/account-settings/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardUsersCreateUserIndexRoute =
  LayoutDashboardUsersCreateUserIndexRouteImport.update({
    id: '/dashboard/users/create-user/',
    path: '/dashboard/users/create-user/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/users/create-user/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardUsersUserIdIndexRoute =
  LayoutDashboardUsersUserIdIndexRouteImport.update({
    id: '/dashboard/users/$userId/',
    path: '/dashboard/users/$userId/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardSitesCreateIndexRoute =
  LayoutDashboardSitesCreateIndexRouteImport.update({
    id: '/dashboard/sites/create/',
    path: '/dashboard/sites/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/sites/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardSitesCreateGroupIndexRoute =
  LayoutDashboardSitesCreateGroupIndexRouteImport.update({
    id: '/dashboard/sites/create-group/',
    path: '/dashboard/sites/create-group/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/sites/create-group/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardSitesCreateGroupSiteIndexRoute =
  LayoutDashboardSitesCreateGroupSiteIndexRouteImport.update({
    id: '/dashboard/sites/create-group-site/',
    path: '/dashboard/sites/create-group-site/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/create-group-site/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesCreateCollectionIndexRoute =
  LayoutDashboardSitesCreateCollectionIndexRouteImport.update({
    id: '/dashboard/sites/create-collection/',
    path: '/dashboard/sites/create-collection/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/create-collection/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdIndexRoute =
  LayoutDashboardSitesSiteIdIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/',
    path: '/dashboard/sites/$siteId/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/sites/$siteId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardSalesAgentsCreateIndexRoute =
  LayoutDashboardSalesAgentsCreateIndexRouteImport.update({
    id: '/dashboard/sales-agents/create/',
    path: '/dashboard/sales-agents/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/sales-agents/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardResellersCreateIndexRoute =
  LayoutDashboardResellersCreateIndexRouteImport.update({
    id: '/dashboard/resellers/create/',
    path: '/dashboard/resellers/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/resellers/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardResellersResellerIdIndexRoute =
  LayoutDashboardResellersResellerIdIndexRouteImport.update({
    id: '/dashboard/resellers/$resellerId/',
    path: '/dashboard/resellers/$resellerId/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardOrganizationsCreateIndexRoute =
  LayoutDashboardOrganizationsCreateIndexRouteImport.update({
    id: '/dashboard/organizations/create/',
    path: '/dashboard/organizations/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/organizations/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardHelpAndSupportContactFormIndexRoute =
  LayoutDashboardHelpAndSupportContactFormIndexRouteImport.update({
    id: '/dashboard/help-and-support/contact-form/',
    path: '/dashboard/help-and-support/contact-form/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/help-and-support/contact-form/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardCommissionsPayoutsReportIndexRoute =
  LayoutDashboardCommissionsPayoutsReportIndexRouteImport.update({
    id: '/dashboard/commissions/payouts-report/',
    path: '/dashboard/commissions/payouts-report/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/commissions/payouts-report/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardCommissionsPaymentHistoryIndexRoute =
  LayoutDashboardCommissionsPaymentHistoryIndexRouteImport.update({
    id: '/dashboard/commissions/payment-history/',
    path: '/dashboard/commissions/payment-history/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/commissions/payment-history/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardCommissionsConfigHistoryIndexRoute =
  LayoutDashboardCommissionsConfigHistoryIndexRouteImport.update({
    id: '/dashboard/commissions/config-history/',
    path: '/dashboard/commissions/config-history/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/commissions/config-history/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardBlogCreateIndexRoute =
  LayoutDashboardBlogCreateIndexRouteImport.update({
    id: '/dashboard/blog/create/',
    path: '/dashboard/blog/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/blog/create/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardBlogBlogIdIndexRoute =
  LayoutDashboardBlogBlogIdIndexRouteImport.update({
    id: '/dashboard/blog/$blogId/',
    path: '/dashboard/blog/$blogId/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/blog/$blogId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardUsersUserIdEditIndexRoute =
  LayoutDashboardUsersUserIdEditIndexRouteImport.update({
    id: '/dashboard/users/$userId/edit/',
    path: '/dashboard/users/$userId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/users/$userId/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardSitesSiteIdSiteCustomizationIndexRoute =
  LayoutDashboardSitesSiteIdSiteCustomizationIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/site-customization/',
    path: '/dashboard/sites/$siteId/site-customization/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/site-customization/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdServiceBlocksIndexRoute =
  LayoutDashboardSitesSiteIdServiceBlocksIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/service-blocks/',
    path: '/dashboard/sites/$siteId/service-blocks/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/service-blocks/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRoute =
  LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/seasonal-cancellation-policies/',
      path: '/dashboard/sites/$siteId/seasonal-cancellation-policies/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/seasonal-cancellation-policies/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomsIndexRoute =
  LayoutDashboardSitesSiteIdRoomsIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rooms/',
    path: '/dashboard/sites/$siteId/rooms/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/sites/$siteId/rooms/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardSitesSiteIdRoomBlocksIndexRoute =
  LayoutDashboardSitesSiteIdRoomBlocksIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/room-blocks/',
    path: '/dashboard/sites/$siteId/room-blocks/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/room-blocks/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRestrictionsIndexRoute =
  LayoutDashboardSitesSiteIdRestrictionsIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/restrictions/',
    path: '/dashboard/sites/$siteId/restrictions/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/restrictions/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdReservationsIndexRoute =
  LayoutDashboardSitesSiteIdReservationsIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/reservations/',
    path: '/dashboard/sites/$siteId/reservations/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/reservations/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdInventoriesIndexRoute =
  LayoutDashboardSitesSiteIdInventoriesIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/inventories/',
    path: '/dashboard/sites/$siteId/inventories/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/inventories/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdIntegrationsIndexRoute =
  LayoutDashboardSitesSiteIdIntegrationsIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/integrations/',
    path: '/dashboard/sites/$siteId/integrations/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/integrations/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdEventsIndexRoute =
  LayoutDashboardSitesSiteIdEventsIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/events/',
    path: '/dashboard/sites/$siteId/events/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/sites/$siteId/events/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardSitesSiteIdDailyPricingIndexRoute =
  LayoutDashboardSitesSiteIdDailyPricingIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/daily-pricing/',
    path: '/dashboard/sites/$siteId/daily-pricing/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/daily-pricing/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRoute =
  LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/activities-and-products/',
    path: '/dashboard/sites/$siteId/activities-and-products/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/activities-and-products/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSalesAgentsAgentIdEditIndexRoute =
  LayoutDashboardSalesAgentsAgentIdEditIndexRouteImport.update({
    id: '/dashboard/sales-agents/$agentId/edit/',
    path: '/dashboard/sales-agents/$agentId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sales-agents/$agentId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardResellersResellerIdEditIndexRoute =
  LayoutDashboardResellersResellerIdEditIndexRouteImport.update({
    id: '/dashboard/resellers/$resellerId/edit/',
    path: '/dashboard/resellers/$resellerId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/resellers/$resellerId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardOrganizationsOrganizationIdEditIndexRoute =
  LayoutDashboardOrganizationsOrganizationIdEditIndexRouteImport.update({
    id: '/dashboard/organizations/$organizationId/edit/',
    path: '/dashboard/organizations/$organizationId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/organizations/$organizationId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRoute =
  LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRouteImport.update(
    {
      id: '/dashboard/help-and-support/quick-answers/update-branding/',
      path: '/dashboard/help-and-support/quick-answers/update-branding/',
      getParentRoute: () => LayoutRoute,
    } as any,
  )
const LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRoute =
  LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRouteImport.update({
    id: '/dashboard/help-and-support/quick-answers/shift4-guide/',
    path: '/dashboard/help-and-support/quick-answers/shift4-guide/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRoute =
  LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRouteImport.update(
    {
      id: '/dashboard/help-and-support/quick-answers/quickbook-integration/',
      path: '/dashboard/help-and-support/quick-answers/quickbook-integration/',
      getParentRoute: () => LayoutRoute,
    } as any,
  )
const LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRoute =
  LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRouteImport.update({
    id: '/dashboard/help-and-support/quick-answers/mews-rates/',
    path: '/dashboard/help-and-support/quick-answers/mews-rates/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRoute =
  LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRouteImport.update({
    id: '/dashboard/help-and-support/quick-answers/mews-packages/',
    path: '/dashboard/help-and-support/quick-answers/mews-packages/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRoute =
  LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRouteImport.update({
    id: '/dashboard/help-and-support/quick-answers/gtm-guide/',
    path: '/dashboard/help-and-support/quick-answers/gtm-guide/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRoute =
  LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRouteImport.update({
    id: '/dashboard/help-and-support/quick-answers/ga4-guide/',
    path: '/dashboard/help-and-support/quick-answers/ga4-guide/',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutDashboardGroupGroupIdPerformanceIndexRoute =
  LayoutDashboardGroupGroupIdPerformanceIndexRouteImport.update({
    id: '/dashboard/group/$groupId/performance/',
    path: '/dashboard/group/$groupId/performance/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/group/$groupId/performance/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardGroupGroupIdEditGroupIndexRoute =
  LayoutDashboardGroupGroupIdEditGroupIndexRouteImport.update({
    id: '/dashboard/group/$groupId/edit-group/',
    path: '/dashboard/group/$groupId/edit-group/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/group/$groupId/edit-group/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardGroupGroupIdCommissionsIndexRoute =
  LayoutDashboardGroupGroupIdCommissionsIndexRouteImport.update({
    id: '/dashboard/group/$groupId/commissions/',
    path: '/dashboard/group/$groupId/commissions/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/group/$groupId/commissions/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardCollectionCollectionIdEditIndexRoute =
  LayoutDashboardCollectionCollectionIdEditIndexRouteImport.update({
    id: '/dashboard/collection/$collectionId/edit/',
    path: '/dashboard/collection/$collectionId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/collection/$collectionId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardBlogBlogIdEditIndexRoute =
  LayoutDashboardBlogBlogIdEditIndexRouteImport.update({
    id: '/dashboard/blog/$blogId/edit/',
    path: '/dashboard/blog/$blogId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import('./routes/_layout/dashboard/blog/$blogId/edit/index.lazy').then(
      (d) => d.Route,
    ),
  )
const LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRoute =
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/site-customization/policies/',
    path: '/dashboard/sites/$siteId/site-customization/policies/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/site-customization/policies/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRoute =
  LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/site-customization/emails/',
    path: '/dashboard/sites/$siteId/site-customization/emails/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/site-customization/emails/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomsCreateIndexRoute =
  LayoutDashboardSitesSiteIdRoomsCreateIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rooms/create/',
    path: '/dashboard/sites/$siteId/rooms/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rooms/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomsAddOnsIndexRoute =
  LayoutDashboardSitesSiteIdRoomsAddOnsIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rooms/add-ons/',
    path: '/dashboard/sites/$siteId/rooms/add-ons/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rooms/add-ons/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRoute =
  LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/room-blocks/create/',
    path: '/dashboard/sites/$siteId/room-blocks/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/room-blocks/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRoute =
  LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/room-blocks/$roomBlockId/',
    path: '/dashboard/sites/$siteId/room-blocks/$roomBlockId/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRestrictionsCreateIndexRoute =
  LayoutDashboardSitesSiteIdRestrictionsCreateIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/restrictions/create/',
    path: '/dashboard/sites/$siteId/restrictions/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/restrictions/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdReservationsWaitlistIndexRoute =
  LayoutDashboardSitesSiteIdReservationsWaitlistIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/reservations/waitlist/',
    path: '/dashboard/sites/$siteId/reservations/waitlist/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/reservations/waitlist/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRoute =
  LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/reservations/$purchaseId/',
    path: '/dashboard/sites/$siteId/reservations/$purchaseId/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/reservations/$purchaseId/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rates-and-packages/rates/',
    path: '/dashboard/sites/$siteId/rates-and-packages/rates/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rates-and-packages/promo-code/',
    path: '/dashboard/sites/$siteId/rates-and-packages/promo-code/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rates-and-packages/packages/',
    path: '/dashboard/sites/$siteId/rates-and-packages/packages/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/packages/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRoute =
  LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/inventories/property-restrictions/',
      path: '/dashboard/sites/$siteId/inventories/property-restrictions/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/inventories/property-restrictions/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdEventsCreateIndexRoute =
  LayoutDashboardSitesSiteIdEventsCreateIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/events/create/',
    path: '/dashboard/sites/$siteId/events/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/events/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdEventsEventIdIndexRoute =
  LayoutDashboardSitesSiteIdEventsEventIdIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/events/$eventId/',
    path: '/dashboard/sites/$siteId/events/$eventId/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/events/$eventId/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRoute =
  LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/activities-and-products/create/',
    path: '/dashboard/sites/$siteId/activities-and-products/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/activities-and-products/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRoute =
  LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rooms/add-ons/create/',
    path: '/dashboard/sites/$siteId/rooms/add-ons/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rooms/add-ons/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rooms/$roomId/edit/',
    path: '/dashboard/sites/$siteId/rooms/$roomId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rooms/$roomId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/',
    path: '/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/restrictions/$restrictionId/edit/',
      path: '/dashboard/sites/$siteId/restrictions/$restrictionId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/restrictions/$restrictionId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rates-and-packages/rates/create/',
    path: '/dashboard/sites/$siteId/rates-and-packages/rates/create/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/',
      path: '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group/',
      path: '/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/promo-code/create/',
      path: '/dashboard/sites/$siteId/rates-and-packages/promo-code/create/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/packages/create/',
      path: '/dashboard/sites/$siteId/rates-and-packages/packages/create/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/packages/create/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdEventsEventIdEditIndexRoute =
  LayoutDashboardSitesSiteIdEventsEventIdEditIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/events/$eventId/edit/',
    path: '/dashboard/sites/$siteId/events/$eventId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/events/$eventId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRoute =
  LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/activities-and-products/$activityId/edit/',
      path: '/dashboard/sites/$siteId/activities-and-products/$activityId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/activities-and-products/$activityId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRoute =
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/',
      path: '/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRoute =
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy/',
      path: '/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRouteImport.update({
    id: '/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit/',
    path: '/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit/',
    getParentRoute: () => LayoutRoute,
  } as any).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit/',
      path: '/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/',
      path: '/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/',
      path: '/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/',
      path: '/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRoute =
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit/',
      path: '/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRoute =
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit/',
      path: '/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit/index.lazy'
    ).then((d) => d.Route),
  )
const LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRoute =
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRouteImport.update(
    {
      id: '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/',
      path: '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/',
      getParentRoute: () => LayoutRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/index.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/dashboard': typeof LayoutDashboardIndexRoute
  '/reset-password/$token': typeof ResetPasswordTokenIndexLazyRoute
  '/dashboard/account-settings': typeof LayoutDashboardAccountSettingsIndexRoute
  '/dashboard/blog': typeof LayoutDashboardBlogIndexRoute
  '/dashboard/commissions': typeof LayoutDashboardCommissionsIndexRoute
  '/dashboard/general': typeof LayoutDashboardGeneralIndexRoute
  '/dashboard/help-and-support': typeof LayoutDashboardHelpAndSupportIndexRoute
  '/dashboard/help': typeof LayoutDashboardHelpIndexRoute
  '/dashboard/organizations': typeof LayoutDashboardOrganizationsIndexRoute
  '/dashboard/resellers': typeof LayoutDashboardResellersIndexRoute
  '/dashboard/sales-agents': typeof LayoutDashboardSalesAgentsIndexRoute
  '/dashboard/sites': typeof LayoutDashboardSitesIndexRoute
  '/dashboard/users': typeof LayoutDashboardUsersIndexRoute
  '/dashboard/blog/$blogId': typeof LayoutDashboardBlogBlogIdIndexRoute
  '/dashboard/blog/create': typeof LayoutDashboardBlogCreateIndexRoute
  '/dashboard/commissions/config-history': typeof LayoutDashboardCommissionsConfigHistoryIndexRoute
  '/dashboard/commissions/payment-history': typeof LayoutDashboardCommissionsPaymentHistoryIndexRoute
  '/dashboard/commissions/payouts-report': typeof LayoutDashboardCommissionsPayoutsReportIndexRoute
  '/dashboard/help-and-support/contact-form': typeof LayoutDashboardHelpAndSupportContactFormIndexRoute
  '/dashboard/organizations/create': typeof LayoutDashboardOrganizationsCreateIndexRoute
  '/dashboard/resellers/$resellerId': typeof LayoutDashboardResellersResellerIdIndexRoute
  '/dashboard/resellers/create': typeof LayoutDashboardResellersCreateIndexRoute
  '/dashboard/sales-agents/create': typeof LayoutDashboardSalesAgentsCreateIndexRoute
  '/dashboard/sites/$siteId': typeof LayoutDashboardSitesSiteIdIndexRoute
  '/dashboard/sites/create-collection': typeof LayoutDashboardSitesCreateCollectionIndexRoute
  '/dashboard/sites/create-group-site': typeof LayoutDashboardSitesCreateGroupSiteIndexRoute
  '/dashboard/sites/create-group': typeof LayoutDashboardSitesCreateGroupIndexRoute
  '/dashboard/sites/create': typeof LayoutDashboardSitesCreateIndexRoute
  '/dashboard/users/$userId': typeof LayoutDashboardUsersUserIdIndexRoute
  '/dashboard/users/create-user': typeof LayoutDashboardUsersCreateUserIndexRoute
  '/dashboard/blog/$blogId/edit': typeof LayoutDashboardBlogBlogIdEditIndexRoute
  '/dashboard/collection/$collectionId/edit': typeof LayoutDashboardCollectionCollectionIdEditIndexRoute
  '/dashboard/group/$groupId/commissions': typeof LayoutDashboardGroupGroupIdCommissionsIndexRoute
  '/dashboard/group/$groupId/edit-group': typeof LayoutDashboardGroupGroupIdEditGroupIndexRoute
  '/dashboard/group/$groupId/performance': typeof LayoutDashboardGroupGroupIdPerformanceIndexRoute
  '/dashboard/help-and-support/quick-answers/ga4-guide': typeof LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRoute
  '/dashboard/help-and-support/quick-answers/gtm-guide': typeof LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRoute
  '/dashboard/help-and-support/quick-answers/mews-packages': typeof LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRoute
  '/dashboard/help-and-support/quick-answers/mews-rates': typeof LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRoute
  '/dashboard/help-and-support/quick-answers/quickbook-integration': typeof LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRoute
  '/dashboard/help-and-support/quick-answers/shift4-guide': typeof LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRoute
  '/dashboard/help-and-support/quick-answers/update-branding': typeof LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRoute
  '/dashboard/organizations/$organizationId/edit': typeof LayoutDashboardOrganizationsOrganizationIdEditIndexRoute
  '/dashboard/resellers/$resellerId/edit': typeof LayoutDashboardResellersResellerIdEditIndexRoute
  '/dashboard/sales-agents/$agentId/edit': typeof LayoutDashboardSalesAgentsAgentIdEditIndexRoute
  '/dashboard/sites/$siteId/activities-and-products': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRoute
  '/dashboard/sites/$siteId/daily-pricing': typeof LayoutDashboardSitesSiteIdDailyPricingIndexRoute
  '/dashboard/sites/$siteId/events': typeof LayoutDashboardSitesSiteIdEventsIndexRoute
  '/dashboard/sites/$siteId/integrations': typeof LayoutDashboardSitesSiteIdIntegrationsIndexRoute
  '/dashboard/sites/$siteId/inventories': typeof LayoutDashboardSitesSiteIdInventoriesIndexRoute
  '/dashboard/sites/$siteId/reservations': typeof LayoutDashboardSitesSiteIdReservationsIndexRoute
  '/dashboard/sites/$siteId/restrictions': typeof LayoutDashboardSitesSiteIdRestrictionsIndexRoute
  '/dashboard/sites/$siteId/room-blocks': typeof LayoutDashboardSitesSiteIdRoomBlocksIndexRoute
  '/dashboard/sites/$siteId/rooms': typeof LayoutDashboardSitesSiteIdRoomsIndexRoute
  '/dashboard/sites/$siteId/seasonal-cancellation-policies': typeof LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRoute
  '/dashboard/sites/$siteId/service-blocks': typeof LayoutDashboardSitesSiteIdServiceBlocksIndexRoute
  '/dashboard/sites/$siteId/site-customization': typeof LayoutDashboardSitesSiteIdSiteCustomizationIndexRoute
  '/dashboard/users/$userId/edit': typeof LayoutDashboardUsersUserIdEditIndexRoute
  '/dashboard/sites/$siteId/activities-and-products/create': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRoute
  '/dashboard/sites/$siteId/events/$eventId': typeof LayoutDashboardSitesSiteIdEventsEventIdIndexRoute
  '/dashboard/sites/$siteId/events/create': typeof LayoutDashboardSitesSiteIdEventsCreateIndexRoute
  '/dashboard/sites/$siteId/inventories/property-restrictions': typeof LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/packages': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/promo-code': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRoute
  '/dashboard/sites/$siteId/reservations/$purchaseId': typeof LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRoute
  '/dashboard/sites/$siteId/reservations/waitlist': typeof LayoutDashboardSitesSiteIdReservationsWaitlistIndexRoute
  '/dashboard/sites/$siteId/restrictions/create': typeof LayoutDashboardSitesSiteIdRestrictionsCreateIndexRoute
  '/dashboard/sites/$siteId/room-blocks/$roomBlockId': typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRoute
  '/dashboard/sites/$siteId/room-blocks/create': typeof LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRoute
  '/dashboard/sites/$siteId/rooms/add-ons': typeof LayoutDashboardSitesSiteIdRoomsAddOnsIndexRoute
  '/dashboard/sites/$siteId/rooms/create': typeof LayoutDashboardSitesSiteIdRoomsCreateIndexRoute
  '/dashboard/sites/$siteId/site-customization/emails': typeof LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRoute
  '/dashboard/sites/$siteId/activities-and-products/$activityId/edit': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRoute
  '/dashboard/sites/$siteId/events/$eventId/edit': typeof LayoutDashboardSitesSiteIdEventsEventIdEditIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/packages/create': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/promo-code/create': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates/create': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRoute
  '/dashboard/sites/$siteId/restrictions/$restrictionId/edit': typeof LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRoute
  '/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit': typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRoute
  '/dashboard/sites/$siteId/rooms/$roomId/edit': typeof LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRoute
  '/dashboard/sites/$siteId/rooms/add-ons/create': typeof LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRoute
  '/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit': typeof LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/dashboard': typeof LayoutDashboardIndexRoute
  '/reset-password/$token': typeof ResetPasswordTokenIndexLazyRoute
  '/dashboard/account-settings': typeof LayoutDashboardAccountSettingsIndexRoute
  '/dashboard/blog': typeof LayoutDashboardBlogIndexRoute
  '/dashboard/commissions': typeof LayoutDashboardCommissionsIndexRoute
  '/dashboard/general': typeof LayoutDashboardGeneralIndexRoute
  '/dashboard/help-and-support': typeof LayoutDashboardHelpAndSupportIndexRoute
  '/dashboard/help': typeof LayoutDashboardHelpIndexRoute
  '/dashboard/organizations': typeof LayoutDashboardOrganizationsIndexRoute
  '/dashboard/resellers': typeof LayoutDashboardResellersIndexRoute
  '/dashboard/sales-agents': typeof LayoutDashboardSalesAgentsIndexRoute
  '/dashboard/sites': typeof LayoutDashboardSitesIndexRoute
  '/dashboard/users': typeof LayoutDashboardUsersIndexRoute
  '/dashboard/blog/$blogId': typeof LayoutDashboardBlogBlogIdIndexRoute
  '/dashboard/blog/create': typeof LayoutDashboardBlogCreateIndexRoute
  '/dashboard/commissions/config-history': typeof LayoutDashboardCommissionsConfigHistoryIndexRoute
  '/dashboard/commissions/payment-history': typeof LayoutDashboardCommissionsPaymentHistoryIndexRoute
  '/dashboard/commissions/payouts-report': typeof LayoutDashboardCommissionsPayoutsReportIndexRoute
  '/dashboard/help-and-support/contact-form': typeof LayoutDashboardHelpAndSupportContactFormIndexRoute
  '/dashboard/organizations/create': typeof LayoutDashboardOrganizationsCreateIndexRoute
  '/dashboard/resellers/$resellerId': typeof LayoutDashboardResellersResellerIdIndexRoute
  '/dashboard/resellers/create': typeof LayoutDashboardResellersCreateIndexRoute
  '/dashboard/sales-agents/create': typeof LayoutDashboardSalesAgentsCreateIndexRoute
  '/dashboard/sites/$siteId': typeof LayoutDashboardSitesSiteIdIndexRoute
  '/dashboard/sites/create-collection': typeof LayoutDashboardSitesCreateCollectionIndexRoute
  '/dashboard/sites/create-group-site': typeof LayoutDashboardSitesCreateGroupSiteIndexRoute
  '/dashboard/sites/create-group': typeof LayoutDashboardSitesCreateGroupIndexRoute
  '/dashboard/sites/create': typeof LayoutDashboardSitesCreateIndexRoute
  '/dashboard/users/$userId': typeof LayoutDashboardUsersUserIdIndexRoute
  '/dashboard/users/create-user': typeof LayoutDashboardUsersCreateUserIndexRoute
  '/dashboard/blog/$blogId/edit': typeof LayoutDashboardBlogBlogIdEditIndexRoute
  '/dashboard/collection/$collectionId/edit': typeof LayoutDashboardCollectionCollectionIdEditIndexRoute
  '/dashboard/group/$groupId/commissions': typeof LayoutDashboardGroupGroupIdCommissionsIndexRoute
  '/dashboard/group/$groupId/edit-group': typeof LayoutDashboardGroupGroupIdEditGroupIndexRoute
  '/dashboard/group/$groupId/performance': typeof LayoutDashboardGroupGroupIdPerformanceIndexRoute
  '/dashboard/help-and-support/quick-answers/ga4-guide': typeof LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRoute
  '/dashboard/help-and-support/quick-answers/gtm-guide': typeof LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRoute
  '/dashboard/help-and-support/quick-answers/mews-packages': typeof LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRoute
  '/dashboard/help-and-support/quick-answers/mews-rates': typeof LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRoute
  '/dashboard/help-and-support/quick-answers/quickbook-integration': typeof LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRoute
  '/dashboard/help-and-support/quick-answers/shift4-guide': typeof LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRoute
  '/dashboard/help-and-support/quick-answers/update-branding': typeof LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRoute
  '/dashboard/organizations/$organizationId/edit': typeof LayoutDashboardOrganizationsOrganizationIdEditIndexRoute
  '/dashboard/resellers/$resellerId/edit': typeof LayoutDashboardResellersResellerIdEditIndexRoute
  '/dashboard/sales-agents/$agentId/edit': typeof LayoutDashboardSalesAgentsAgentIdEditIndexRoute
  '/dashboard/sites/$siteId/activities-and-products': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRoute
  '/dashboard/sites/$siteId/daily-pricing': typeof LayoutDashboardSitesSiteIdDailyPricingIndexRoute
  '/dashboard/sites/$siteId/events': typeof LayoutDashboardSitesSiteIdEventsIndexRoute
  '/dashboard/sites/$siteId/integrations': typeof LayoutDashboardSitesSiteIdIntegrationsIndexRoute
  '/dashboard/sites/$siteId/inventories': typeof LayoutDashboardSitesSiteIdInventoriesIndexRoute
  '/dashboard/sites/$siteId/reservations': typeof LayoutDashboardSitesSiteIdReservationsIndexRoute
  '/dashboard/sites/$siteId/restrictions': typeof LayoutDashboardSitesSiteIdRestrictionsIndexRoute
  '/dashboard/sites/$siteId/room-blocks': typeof LayoutDashboardSitesSiteIdRoomBlocksIndexRoute
  '/dashboard/sites/$siteId/rooms': typeof LayoutDashboardSitesSiteIdRoomsIndexRoute
  '/dashboard/sites/$siteId/seasonal-cancellation-policies': typeof LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRoute
  '/dashboard/sites/$siteId/service-blocks': typeof LayoutDashboardSitesSiteIdServiceBlocksIndexRoute
  '/dashboard/sites/$siteId/site-customization': typeof LayoutDashboardSitesSiteIdSiteCustomizationIndexRoute
  '/dashboard/users/$userId/edit': typeof LayoutDashboardUsersUserIdEditIndexRoute
  '/dashboard/sites/$siteId/activities-and-products/create': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRoute
  '/dashboard/sites/$siteId/events/$eventId': typeof LayoutDashboardSitesSiteIdEventsEventIdIndexRoute
  '/dashboard/sites/$siteId/events/create': typeof LayoutDashboardSitesSiteIdEventsCreateIndexRoute
  '/dashboard/sites/$siteId/inventories/property-restrictions': typeof LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/packages': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/promo-code': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRoute
  '/dashboard/sites/$siteId/reservations/$purchaseId': typeof LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRoute
  '/dashboard/sites/$siteId/reservations/waitlist': typeof LayoutDashboardSitesSiteIdReservationsWaitlistIndexRoute
  '/dashboard/sites/$siteId/restrictions/create': typeof LayoutDashboardSitesSiteIdRestrictionsCreateIndexRoute
  '/dashboard/sites/$siteId/room-blocks/$roomBlockId': typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRoute
  '/dashboard/sites/$siteId/room-blocks/create': typeof LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRoute
  '/dashboard/sites/$siteId/rooms/add-ons': typeof LayoutDashboardSitesSiteIdRoomsAddOnsIndexRoute
  '/dashboard/sites/$siteId/rooms/create': typeof LayoutDashboardSitesSiteIdRoomsCreateIndexRoute
  '/dashboard/sites/$siteId/site-customization/emails': typeof LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRoute
  '/dashboard/sites/$siteId/activities-and-products/$activityId/edit': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRoute
  '/dashboard/sites/$siteId/events/$eventId/edit': typeof LayoutDashboardSitesSiteIdEventsEventIdEditIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/packages/create': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/promo-code/create': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates/create': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRoute
  '/dashboard/sites/$siteId/restrictions/$restrictionId/edit': typeof LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRoute
  '/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit': typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRoute
  '/dashboard/sites/$siteId/rooms/$roomId/edit': typeof LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRoute
  '/dashboard/sites/$siteId/rooms/add-ons/create': typeof LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRoute
  '/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit': typeof LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRoute
  '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRoute
  '/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/forgot-password': typeof ForgotPasswordLazyRoute
  '/_layout/dashboard/': typeof LayoutDashboardIndexRoute
  '/reset-password/$token/': typeof ResetPasswordTokenIndexLazyRoute
  '/_layout/dashboard/account-settings/': typeof LayoutDashboardAccountSettingsIndexRoute
  '/_layout/dashboard/blog/': typeof LayoutDashboardBlogIndexRoute
  '/_layout/dashboard/commissions/': typeof LayoutDashboardCommissionsIndexRoute
  '/_layout/dashboard/general/': typeof LayoutDashboardGeneralIndexRoute
  '/_layout/dashboard/help-and-support/': typeof LayoutDashboardHelpAndSupportIndexRoute
  '/_layout/dashboard/help/': typeof LayoutDashboardHelpIndexRoute
  '/_layout/dashboard/organizations/': typeof LayoutDashboardOrganizationsIndexRoute
  '/_layout/dashboard/resellers/': typeof LayoutDashboardResellersIndexRoute
  '/_layout/dashboard/sales-agents/': typeof LayoutDashboardSalesAgentsIndexRoute
  '/_layout/dashboard/sites/': typeof LayoutDashboardSitesIndexRoute
  '/_layout/dashboard/users/': typeof LayoutDashboardUsersIndexRoute
  '/_layout/dashboard/blog/$blogId/': typeof LayoutDashboardBlogBlogIdIndexRoute
  '/_layout/dashboard/blog/create/': typeof LayoutDashboardBlogCreateIndexRoute
  '/_layout/dashboard/commissions/config-history/': typeof LayoutDashboardCommissionsConfigHistoryIndexRoute
  '/_layout/dashboard/commissions/payment-history/': typeof LayoutDashboardCommissionsPaymentHistoryIndexRoute
  '/_layout/dashboard/commissions/payouts-report/': typeof LayoutDashboardCommissionsPayoutsReportIndexRoute
  '/_layout/dashboard/help-and-support/contact-form/': typeof LayoutDashboardHelpAndSupportContactFormIndexRoute
  '/_layout/dashboard/organizations/create/': typeof LayoutDashboardOrganizationsCreateIndexRoute
  '/_layout/dashboard/resellers/$resellerId/': typeof LayoutDashboardResellersResellerIdIndexRoute
  '/_layout/dashboard/resellers/create/': typeof LayoutDashboardResellersCreateIndexRoute
  '/_layout/dashboard/sales-agents/create/': typeof LayoutDashboardSalesAgentsCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/': typeof LayoutDashboardSitesSiteIdIndexRoute
  '/_layout/dashboard/sites/create-collection/': typeof LayoutDashboardSitesCreateCollectionIndexRoute
  '/_layout/dashboard/sites/create-group-site/': typeof LayoutDashboardSitesCreateGroupSiteIndexRoute
  '/_layout/dashboard/sites/create-group/': typeof LayoutDashboardSitesCreateGroupIndexRoute
  '/_layout/dashboard/sites/create/': typeof LayoutDashboardSitesCreateIndexRoute
  '/_layout/dashboard/users/$userId/': typeof LayoutDashboardUsersUserIdIndexRoute
  '/_layout/dashboard/users/create-user/': typeof LayoutDashboardUsersCreateUserIndexRoute
  '/_layout/dashboard/blog/$blogId/edit/': typeof LayoutDashboardBlogBlogIdEditIndexRoute
  '/_layout/dashboard/collection/$collectionId/edit/': typeof LayoutDashboardCollectionCollectionIdEditIndexRoute
  '/_layout/dashboard/group/$groupId/commissions/': typeof LayoutDashboardGroupGroupIdCommissionsIndexRoute
  '/_layout/dashboard/group/$groupId/edit-group/': typeof LayoutDashboardGroupGroupIdEditGroupIndexRoute
  '/_layout/dashboard/group/$groupId/performance/': typeof LayoutDashboardGroupGroupIdPerformanceIndexRoute
  '/_layout/dashboard/help-and-support/quick-answers/ga4-guide/': typeof LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRoute
  '/_layout/dashboard/help-and-support/quick-answers/gtm-guide/': typeof LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRoute
  '/_layout/dashboard/help-and-support/quick-answers/mews-packages/': typeof LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRoute
  '/_layout/dashboard/help-and-support/quick-answers/mews-rates/': typeof LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRoute
  '/_layout/dashboard/help-and-support/quick-answers/quickbook-integration/': typeof LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRoute
  '/_layout/dashboard/help-and-support/quick-answers/shift4-guide/': typeof LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRoute
  '/_layout/dashboard/help-and-support/quick-answers/update-branding/': typeof LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRoute
  '/_layout/dashboard/organizations/$organizationId/edit/': typeof LayoutDashboardOrganizationsOrganizationIdEditIndexRoute
  '/_layout/dashboard/resellers/$resellerId/edit/': typeof LayoutDashboardResellersResellerIdEditIndexRoute
  '/_layout/dashboard/sales-agents/$agentId/edit/': typeof LayoutDashboardSalesAgentsAgentIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/activities-and-products/': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRoute
  '/_layout/dashboard/sites/$siteId/daily-pricing/': typeof LayoutDashboardSitesSiteIdDailyPricingIndexRoute
  '/_layout/dashboard/sites/$siteId/events/': typeof LayoutDashboardSitesSiteIdEventsIndexRoute
  '/_layout/dashboard/sites/$siteId/integrations/': typeof LayoutDashboardSitesSiteIdIntegrationsIndexRoute
  '/_layout/dashboard/sites/$siteId/inventories/': typeof LayoutDashboardSitesSiteIdInventoriesIndexRoute
  '/_layout/dashboard/sites/$siteId/reservations/': typeof LayoutDashboardSitesSiteIdReservationsIndexRoute
  '/_layout/dashboard/sites/$siteId/restrictions/': typeof LayoutDashboardSitesSiteIdRestrictionsIndexRoute
  '/_layout/dashboard/sites/$siteId/room-blocks/': typeof LayoutDashboardSitesSiteIdRoomBlocksIndexRoute
  '/_layout/dashboard/sites/$siteId/rooms/': typeof LayoutDashboardSitesSiteIdRoomsIndexRoute
  '/_layout/dashboard/sites/$siteId/seasonal-cancellation-policies/': typeof LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRoute
  '/_layout/dashboard/sites/$siteId/service-blocks/': typeof LayoutDashboardSitesSiteIdServiceBlocksIndexRoute
  '/_layout/dashboard/sites/$siteId/site-customization/': typeof LayoutDashboardSitesSiteIdSiteCustomizationIndexRoute
  '/_layout/dashboard/users/$userId/edit/': typeof LayoutDashboardUsersUserIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/activities-and-products/create/': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/events/$eventId/': typeof LayoutDashboardSitesSiteIdEventsEventIdIndexRoute
  '/_layout/dashboard/sites/$siteId/events/create/': typeof LayoutDashboardSitesSiteIdEventsCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/inventories/property-restrictions/': typeof LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRoute
  '/_layout/dashboard/sites/$siteId/reservations/$purchaseId/': typeof LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRoute
  '/_layout/dashboard/sites/$siteId/reservations/waitlist/': typeof LayoutDashboardSitesSiteIdReservationsWaitlistIndexRoute
  '/_layout/dashboard/sites/$siteId/restrictions/create/': typeof LayoutDashboardSitesSiteIdRestrictionsCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/': typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRoute
  '/_layout/dashboard/sites/$siteId/room-blocks/create/': typeof LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/rooms/add-ons/': typeof LayoutDashboardSitesSiteIdRoomsAddOnsIndexRoute
  '/_layout/dashboard/sites/$siteId/rooms/create/': typeof LayoutDashboardSitesSiteIdRoomsCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/site-customization/emails/': typeof LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRoute
  '/_layout/dashboard/sites/$siteId/site-customization/policies/': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRoute
  '/_layout/dashboard/sites/$siteId/activities-and-products/$activityId/edit/': typeof LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/events/$eventId/edit/': typeof LayoutDashboardSitesSiteIdEventsEventIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/create/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/create/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/restrictions/$restrictionId/edit/': typeof LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/': typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/rooms/$roomId/edit/': typeof LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/rooms/add-ons/create/': typeof LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit/': typeof LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy/': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRoute
  '/_layout/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRoute
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/': typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit/': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRoute
  '/_layout/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit/': typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/dashboard'
    | '/reset-password/$token'
    | '/dashboard/account-settings'
    | '/dashboard/blog'
    | '/dashboard/commissions'
    | '/dashboard/general'
    | '/dashboard/help-and-support'
    | '/dashboard/help'
    | '/dashboard/organizations'
    | '/dashboard/resellers'
    | '/dashboard/sales-agents'
    | '/dashboard/sites'
    | '/dashboard/users'
    | '/dashboard/blog/$blogId'
    | '/dashboard/blog/create'
    | '/dashboard/commissions/config-history'
    | '/dashboard/commissions/payment-history'
    | '/dashboard/commissions/payouts-report'
    | '/dashboard/help-and-support/contact-form'
    | '/dashboard/organizations/create'
    | '/dashboard/resellers/$resellerId'
    | '/dashboard/resellers/create'
    | '/dashboard/sales-agents/create'
    | '/dashboard/sites/$siteId'
    | '/dashboard/sites/create-collection'
    | '/dashboard/sites/create-group-site'
    | '/dashboard/sites/create-group'
    | '/dashboard/sites/create'
    | '/dashboard/users/$userId'
    | '/dashboard/users/create-user'
    | '/dashboard/blog/$blogId/edit'
    | '/dashboard/collection/$collectionId/edit'
    | '/dashboard/group/$groupId/commissions'
    | '/dashboard/group/$groupId/edit-group'
    | '/dashboard/group/$groupId/performance'
    | '/dashboard/help-and-support/quick-answers/ga4-guide'
    | '/dashboard/help-and-support/quick-answers/gtm-guide'
    | '/dashboard/help-and-support/quick-answers/mews-packages'
    | '/dashboard/help-and-support/quick-answers/mews-rates'
    | '/dashboard/help-and-support/quick-answers/quickbook-integration'
    | '/dashboard/help-and-support/quick-answers/shift4-guide'
    | '/dashboard/help-and-support/quick-answers/update-branding'
    | '/dashboard/organizations/$organizationId/edit'
    | '/dashboard/resellers/$resellerId/edit'
    | '/dashboard/sales-agents/$agentId/edit'
    | '/dashboard/sites/$siteId/activities-and-products'
    | '/dashboard/sites/$siteId/daily-pricing'
    | '/dashboard/sites/$siteId/events'
    | '/dashboard/sites/$siteId/integrations'
    | '/dashboard/sites/$siteId/inventories'
    | '/dashboard/sites/$siteId/reservations'
    | '/dashboard/sites/$siteId/restrictions'
    | '/dashboard/sites/$siteId/room-blocks'
    | '/dashboard/sites/$siteId/rooms'
    | '/dashboard/sites/$siteId/seasonal-cancellation-policies'
    | '/dashboard/sites/$siteId/service-blocks'
    | '/dashboard/sites/$siteId/site-customization'
    | '/dashboard/users/$userId/edit'
    | '/dashboard/sites/$siteId/activities-and-products/create'
    | '/dashboard/sites/$siteId/events/$eventId'
    | '/dashboard/sites/$siteId/events/create'
    | '/dashboard/sites/$siteId/inventories/property-restrictions'
    | '/dashboard/sites/$siteId/rates-and-packages/packages'
    | '/dashboard/sites/$siteId/rates-and-packages/promo-code'
    | '/dashboard/sites/$siteId/rates-and-packages/rates'
    | '/dashboard/sites/$siteId/reservations/$purchaseId'
    | '/dashboard/sites/$siteId/reservations/waitlist'
    | '/dashboard/sites/$siteId/restrictions/create'
    | '/dashboard/sites/$siteId/room-blocks/$roomBlockId'
    | '/dashboard/sites/$siteId/room-blocks/create'
    | '/dashboard/sites/$siteId/rooms/add-ons'
    | '/dashboard/sites/$siteId/rooms/create'
    | '/dashboard/sites/$siteId/site-customization/emails'
    | '/dashboard/sites/$siteId/site-customization/policies'
    | '/dashboard/sites/$siteId/activities-and-products/$activityId/edit'
    | '/dashboard/sites/$siteId/events/$eventId/edit'
    | '/dashboard/sites/$siteId/rates-and-packages/packages/create'
    | '/dashboard/sites/$siteId/rates-and-packages/promo-code/create'
    | '/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group'
    | '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate'
    | '/dashboard/sites/$siteId/rates-and-packages/rates/create'
    | '/dashboard/sites/$siteId/restrictions/$restrictionId/edit'
    | '/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit'
    | '/dashboard/sites/$siteId/rooms/$roomId/edit'
    | '/dashboard/sites/$siteId/rooms/add-ons/create'
    | '/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit'
    | '/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit'
    | '/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit'
    | '/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit'
    | '/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit'
    | '/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy'
    | '/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy'
    | '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit'
    | '/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit'
    | '/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/dashboard'
    | '/reset-password/$token'
    | '/dashboard/account-settings'
    | '/dashboard/blog'
    | '/dashboard/commissions'
    | '/dashboard/general'
    | '/dashboard/help-and-support'
    | '/dashboard/help'
    | '/dashboard/organizations'
    | '/dashboard/resellers'
    | '/dashboard/sales-agents'
    | '/dashboard/sites'
    | '/dashboard/users'
    | '/dashboard/blog/$blogId'
    | '/dashboard/blog/create'
    | '/dashboard/commissions/config-history'
    | '/dashboard/commissions/payment-history'
    | '/dashboard/commissions/payouts-report'
    | '/dashboard/help-and-support/contact-form'
    | '/dashboard/organizations/create'
    | '/dashboard/resellers/$resellerId'
    | '/dashboard/resellers/create'
    | '/dashboard/sales-agents/create'
    | '/dashboard/sites/$siteId'
    | '/dashboard/sites/create-collection'
    | '/dashboard/sites/create-group-site'
    | '/dashboard/sites/create-group'
    | '/dashboard/sites/create'
    | '/dashboard/users/$userId'
    | '/dashboard/users/create-user'
    | '/dashboard/blog/$blogId/edit'
    | '/dashboard/collection/$collectionId/edit'
    | '/dashboard/group/$groupId/commissions'
    | '/dashboard/group/$groupId/edit-group'
    | '/dashboard/group/$groupId/performance'
    | '/dashboard/help-and-support/quick-answers/ga4-guide'
    | '/dashboard/help-and-support/quick-answers/gtm-guide'
    | '/dashboard/help-and-support/quick-answers/mews-packages'
    | '/dashboard/help-and-support/quick-answers/mews-rates'
    | '/dashboard/help-and-support/quick-answers/quickbook-integration'
    | '/dashboard/help-and-support/quick-answers/shift4-guide'
    | '/dashboard/help-and-support/quick-answers/update-branding'
    | '/dashboard/organizations/$organizationId/edit'
    | '/dashboard/resellers/$resellerId/edit'
    | '/dashboard/sales-agents/$agentId/edit'
    | '/dashboard/sites/$siteId/activities-and-products'
    | '/dashboard/sites/$siteId/daily-pricing'
    | '/dashboard/sites/$siteId/events'
    | '/dashboard/sites/$siteId/integrations'
    | '/dashboard/sites/$siteId/inventories'
    | '/dashboard/sites/$siteId/reservations'
    | '/dashboard/sites/$siteId/restrictions'
    | '/dashboard/sites/$siteId/room-blocks'
    | '/dashboard/sites/$siteId/rooms'
    | '/dashboard/sites/$siteId/seasonal-cancellation-policies'
    | '/dashboard/sites/$siteId/service-blocks'
    | '/dashboard/sites/$siteId/site-customization'
    | '/dashboard/users/$userId/edit'
    | '/dashboard/sites/$siteId/activities-and-products/create'
    | '/dashboard/sites/$siteId/events/$eventId'
    | '/dashboard/sites/$siteId/events/create'
    | '/dashboard/sites/$siteId/inventories/property-restrictions'
    | '/dashboard/sites/$siteId/rates-and-packages/packages'
    | '/dashboard/sites/$siteId/rates-and-packages/promo-code'
    | '/dashboard/sites/$siteId/rates-and-packages/rates'
    | '/dashboard/sites/$siteId/reservations/$purchaseId'
    | '/dashboard/sites/$siteId/reservations/waitlist'
    | '/dashboard/sites/$siteId/restrictions/create'
    | '/dashboard/sites/$siteId/room-blocks/$roomBlockId'
    | '/dashboard/sites/$siteId/room-blocks/create'
    | '/dashboard/sites/$siteId/rooms/add-ons'
    | '/dashboard/sites/$siteId/rooms/create'
    | '/dashboard/sites/$siteId/site-customization/emails'
    | '/dashboard/sites/$siteId/site-customization/policies'
    | '/dashboard/sites/$siteId/activities-and-products/$activityId/edit'
    | '/dashboard/sites/$siteId/events/$eventId/edit'
    | '/dashboard/sites/$siteId/rates-and-packages/packages/create'
    | '/dashboard/sites/$siteId/rates-and-packages/promo-code/create'
    | '/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group'
    | '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate'
    | '/dashboard/sites/$siteId/rates-and-packages/rates/create'
    | '/dashboard/sites/$siteId/restrictions/$restrictionId/edit'
    | '/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit'
    | '/dashboard/sites/$siteId/rooms/$roomId/edit'
    | '/dashboard/sites/$siteId/rooms/add-ons/create'
    | '/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit'
    | '/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit'
    | '/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit'
    | '/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit'
    | '/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit'
    | '/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy'
    | '/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy'
    | '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit'
    | '/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit'
    | '/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/forgot-password'
    | '/_layout/dashboard/'
    | '/reset-password/$token/'
    | '/_layout/dashboard/account-settings/'
    | '/_layout/dashboard/blog/'
    | '/_layout/dashboard/commissions/'
    | '/_layout/dashboard/general/'
    | '/_layout/dashboard/help-and-support/'
    | '/_layout/dashboard/help/'
    | '/_layout/dashboard/organizations/'
    | '/_layout/dashboard/resellers/'
    | '/_layout/dashboard/sales-agents/'
    | '/_layout/dashboard/sites/'
    | '/_layout/dashboard/users/'
    | '/_layout/dashboard/blog/$blogId/'
    | '/_layout/dashboard/blog/create/'
    | '/_layout/dashboard/commissions/config-history/'
    | '/_layout/dashboard/commissions/payment-history/'
    | '/_layout/dashboard/commissions/payouts-report/'
    | '/_layout/dashboard/help-and-support/contact-form/'
    | '/_layout/dashboard/organizations/create/'
    | '/_layout/dashboard/resellers/$resellerId/'
    | '/_layout/dashboard/resellers/create/'
    | '/_layout/dashboard/sales-agents/create/'
    | '/_layout/dashboard/sites/$siteId/'
    | '/_layout/dashboard/sites/create-collection/'
    | '/_layout/dashboard/sites/create-group-site/'
    | '/_layout/dashboard/sites/create-group/'
    | '/_layout/dashboard/sites/create/'
    | '/_layout/dashboard/users/$userId/'
    | '/_layout/dashboard/users/create-user/'
    | '/_layout/dashboard/blog/$blogId/edit/'
    | '/_layout/dashboard/collection/$collectionId/edit/'
    | '/_layout/dashboard/group/$groupId/commissions/'
    | '/_layout/dashboard/group/$groupId/edit-group/'
    | '/_layout/dashboard/group/$groupId/performance/'
    | '/_layout/dashboard/help-and-support/quick-answers/ga4-guide/'
    | '/_layout/dashboard/help-and-support/quick-answers/gtm-guide/'
    | '/_layout/dashboard/help-and-support/quick-answers/mews-packages/'
    | '/_layout/dashboard/help-and-support/quick-answers/mews-rates/'
    | '/_layout/dashboard/help-and-support/quick-answers/quickbook-integration/'
    | '/_layout/dashboard/help-and-support/quick-answers/shift4-guide/'
    | '/_layout/dashboard/help-and-support/quick-answers/update-branding/'
    | '/_layout/dashboard/organizations/$organizationId/edit/'
    | '/_layout/dashboard/resellers/$resellerId/edit/'
    | '/_layout/dashboard/sales-agents/$agentId/edit/'
    | '/_layout/dashboard/sites/$siteId/activities-and-products/'
    | '/_layout/dashboard/sites/$siteId/daily-pricing/'
    | '/_layout/dashboard/sites/$siteId/events/'
    | '/_layout/dashboard/sites/$siteId/integrations/'
    | '/_layout/dashboard/sites/$siteId/inventories/'
    | '/_layout/dashboard/sites/$siteId/reservations/'
    | '/_layout/dashboard/sites/$siteId/restrictions/'
    | '/_layout/dashboard/sites/$siteId/room-blocks/'
    | '/_layout/dashboard/sites/$siteId/rooms/'
    | '/_layout/dashboard/sites/$siteId/seasonal-cancellation-policies/'
    | '/_layout/dashboard/sites/$siteId/service-blocks/'
    | '/_layout/dashboard/sites/$siteId/site-customization/'
    | '/_layout/dashboard/users/$userId/edit/'
    | '/_layout/dashboard/sites/$siteId/activities-and-products/create/'
    | '/_layout/dashboard/sites/$siteId/events/$eventId/'
    | '/_layout/dashboard/sites/$siteId/events/create/'
    | '/_layout/dashboard/sites/$siteId/inventories/property-restrictions/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/'
    | '/_layout/dashboard/sites/$siteId/reservations/$purchaseId/'
    | '/_layout/dashboard/sites/$siteId/reservations/waitlist/'
    | '/_layout/dashboard/sites/$siteId/restrictions/create/'
    | '/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/'
    | '/_layout/dashboard/sites/$siteId/room-blocks/create/'
    | '/_layout/dashboard/sites/$siteId/rooms/add-ons/'
    | '/_layout/dashboard/sites/$siteId/rooms/create/'
    | '/_layout/dashboard/sites/$siteId/site-customization/emails/'
    | '/_layout/dashboard/sites/$siteId/site-customization/policies/'
    | '/_layout/dashboard/sites/$siteId/activities-and-products/$activityId/edit/'
    | '/_layout/dashboard/sites/$siteId/events/$eventId/edit/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/create/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/create/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create/'
    | '/_layout/dashboard/sites/$siteId/restrictions/$restrictionId/edit/'
    | '/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/'
    | '/_layout/dashboard/sites/$siteId/rooms/$roomId/edit/'
    | '/_layout/dashboard/sites/$siteId/rooms/add-ons/create/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit/'
    | '/_layout/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit/'
    | '/_layout/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy/'
    | '/_layout/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/'
    | '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/'
    | '/_layout/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit/'
    | '/_layout/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LayoutRoute: typeof LayoutRouteWithChildren
  ForgotPasswordLazyRoute: typeof ForgotPasswordLazyRoute
  ResetPasswordTokenIndexLazyRoute: typeof ResetPasswordTokenIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token/': {
      id: '/reset-password/$token/'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/dashboard/': {
      id: '/_layout/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof LayoutDashboardIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/users/': {
      id: '/_layout/dashboard/users/'
      path: '/dashboard/users'
      fullPath: '/dashboard/users'
      preLoaderRoute: typeof LayoutDashboardUsersIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/': {
      id: '/_layout/dashboard/sites/'
      path: '/dashboard/sites'
      fullPath: '/dashboard/sites'
      preLoaderRoute: typeof LayoutDashboardSitesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sales-agents/': {
      id: '/_layout/dashboard/sales-agents/'
      path: '/dashboard/sales-agents'
      fullPath: '/dashboard/sales-agents'
      preLoaderRoute: typeof LayoutDashboardSalesAgentsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/resellers/': {
      id: '/_layout/dashboard/resellers/'
      path: '/dashboard/resellers'
      fullPath: '/dashboard/resellers'
      preLoaderRoute: typeof LayoutDashboardResellersIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/organizations/': {
      id: '/_layout/dashboard/organizations/'
      path: '/dashboard/organizations'
      fullPath: '/dashboard/organizations'
      preLoaderRoute: typeof LayoutDashboardOrganizationsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help/': {
      id: '/_layout/dashboard/help/'
      path: '/dashboard/help'
      fullPath: '/dashboard/help'
      preLoaderRoute: typeof LayoutDashboardHelpIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/': {
      id: '/_layout/dashboard/help-and-support/'
      path: '/dashboard/help-and-support'
      fullPath: '/dashboard/help-and-support'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/general/': {
      id: '/_layout/dashboard/general/'
      path: '/dashboard/general'
      fullPath: '/dashboard/general'
      preLoaderRoute: typeof LayoutDashboardGeneralIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/commissions/': {
      id: '/_layout/dashboard/commissions/'
      path: '/dashboard/commissions'
      fullPath: '/dashboard/commissions'
      preLoaderRoute: typeof LayoutDashboardCommissionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/blog/': {
      id: '/_layout/dashboard/blog/'
      path: '/dashboard/blog'
      fullPath: '/dashboard/blog'
      preLoaderRoute: typeof LayoutDashboardBlogIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/account-settings/': {
      id: '/_layout/dashboard/account-settings/'
      path: '/dashboard/account-settings'
      fullPath: '/dashboard/account-settings'
      preLoaderRoute: typeof LayoutDashboardAccountSettingsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/users/create-user/': {
      id: '/_layout/dashboard/users/create-user/'
      path: '/dashboard/users/create-user'
      fullPath: '/dashboard/users/create-user'
      preLoaderRoute: typeof LayoutDashboardUsersCreateUserIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/users/$userId/': {
      id: '/_layout/dashboard/users/$userId/'
      path: '/dashboard/users/$userId'
      fullPath: '/dashboard/users/$userId'
      preLoaderRoute: typeof LayoutDashboardUsersUserIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/create/': {
      id: '/_layout/dashboard/sites/create/'
      path: '/dashboard/sites/create'
      fullPath: '/dashboard/sites/create'
      preLoaderRoute: typeof LayoutDashboardSitesCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/create-group/': {
      id: '/_layout/dashboard/sites/create-group/'
      path: '/dashboard/sites/create-group'
      fullPath: '/dashboard/sites/create-group'
      preLoaderRoute: typeof LayoutDashboardSitesCreateGroupIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/create-group-site/': {
      id: '/_layout/dashboard/sites/create-group-site/'
      path: '/dashboard/sites/create-group-site'
      fullPath: '/dashboard/sites/create-group-site'
      preLoaderRoute: typeof LayoutDashboardSitesCreateGroupSiteIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/create-collection/': {
      id: '/_layout/dashboard/sites/create-collection/'
      path: '/dashboard/sites/create-collection'
      fullPath: '/dashboard/sites/create-collection'
      preLoaderRoute: typeof LayoutDashboardSitesCreateCollectionIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/': {
      id: '/_layout/dashboard/sites/$siteId/'
      path: '/dashboard/sites/$siteId'
      fullPath: '/dashboard/sites/$siteId'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sales-agents/create/': {
      id: '/_layout/dashboard/sales-agents/create/'
      path: '/dashboard/sales-agents/create'
      fullPath: '/dashboard/sales-agents/create'
      preLoaderRoute: typeof LayoutDashboardSalesAgentsCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/resellers/create/': {
      id: '/_layout/dashboard/resellers/create/'
      path: '/dashboard/resellers/create'
      fullPath: '/dashboard/resellers/create'
      preLoaderRoute: typeof LayoutDashboardResellersCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/resellers/$resellerId/': {
      id: '/_layout/dashboard/resellers/$resellerId/'
      path: '/dashboard/resellers/$resellerId'
      fullPath: '/dashboard/resellers/$resellerId'
      preLoaderRoute: typeof LayoutDashboardResellersResellerIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/organizations/create/': {
      id: '/_layout/dashboard/organizations/create/'
      path: '/dashboard/organizations/create'
      fullPath: '/dashboard/organizations/create'
      preLoaderRoute: typeof LayoutDashboardOrganizationsCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/contact-form/': {
      id: '/_layout/dashboard/help-and-support/contact-form/'
      path: '/dashboard/help-and-support/contact-form'
      fullPath: '/dashboard/help-and-support/contact-form'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportContactFormIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/commissions/payouts-report/': {
      id: '/_layout/dashboard/commissions/payouts-report/'
      path: '/dashboard/commissions/payouts-report'
      fullPath: '/dashboard/commissions/payouts-report'
      preLoaderRoute: typeof LayoutDashboardCommissionsPayoutsReportIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/commissions/payment-history/': {
      id: '/_layout/dashboard/commissions/payment-history/'
      path: '/dashboard/commissions/payment-history'
      fullPath: '/dashboard/commissions/payment-history'
      preLoaderRoute: typeof LayoutDashboardCommissionsPaymentHistoryIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/commissions/config-history/': {
      id: '/_layout/dashboard/commissions/config-history/'
      path: '/dashboard/commissions/config-history'
      fullPath: '/dashboard/commissions/config-history'
      preLoaderRoute: typeof LayoutDashboardCommissionsConfigHistoryIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/blog/create/': {
      id: '/_layout/dashboard/blog/create/'
      path: '/dashboard/blog/create'
      fullPath: '/dashboard/blog/create'
      preLoaderRoute: typeof LayoutDashboardBlogCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/blog/$blogId/': {
      id: '/_layout/dashboard/blog/$blogId/'
      path: '/dashboard/blog/$blogId'
      fullPath: '/dashboard/blog/$blogId'
      preLoaderRoute: typeof LayoutDashboardBlogBlogIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/users/$userId/edit/': {
      id: '/_layout/dashboard/users/$userId/edit/'
      path: '/dashboard/users/$userId/edit'
      fullPath: '/dashboard/users/$userId/edit'
      preLoaderRoute: typeof LayoutDashboardUsersUserIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/site-customization/': {
      id: '/_layout/dashboard/sites/$siteId/site-customization/'
      path: '/dashboard/sites/$siteId/site-customization'
      fullPath: '/dashboard/sites/$siteId/site-customization'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/service-blocks/': {
      id: '/_layout/dashboard/sites/$siteId/service-blocks/'
      path: '/dashboard/sites/$siteId/service-blocks'
      fullPath: '/dashboard/sites/$siteId/service-blocks'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdServiceBlocksIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/seasonal-cancellation-policies/': {
      id: '/_layout/dashboard/sites/$siteId/seasonal-cancellation-policies/'
      path: '/dashboard/sites/$siteId/seasonal-cancellation-policies'
      fullPath: '/dashboard/sites/$siteId/seasonal-cancellation-policies'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rooms/': {
      id: '/_layout/dashboard/sites/$siteId/rooms/'
      path: '/dashboard/sites/$siteId/rooms'
      fullPath: '/dashboard/sites/$siteId/rooms'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/room-blocks/': {
      id: '/_layout/dashboard/sites/$siteId/room-blocks/'
      path: '/dashboard/sites/$siteId/room-blocks'
      fullPath: '/dashboard/sites/$siteId/room-blocks'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomBlocksIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/restrictions/': {
      id: '/_layout/dashboard/sites/$siteId/restrictions/'
      path: '/dashboard/sites/$siteId/restrictions'
      fullPath: '/dashboard/sites/$siteId/restrictions'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRestrictionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/reservations/': {
      id: '/_layout/dashboard/sites/$siteId/reservations/'
      path: '/dashboard/sites/$siteId/reservations'
      fullPath: '/dashboard/sites/$siteId/reservations'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdReservationsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/inventories/': {
      id: '/_layout/dashboard/sites/$siteId/inventories/'
      path: '/dashboard/sites/$siteId/inventories'
      fullPath: '/dashboard/sites/$siteId/inventories'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdInventoriesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/integrations/': {
      id: '/_layout/dashboard/sites/$siteId/integrations/'
      path: '/dashboard/sites/$siteId/integrations'
      fullPath: '/dashboard/sites/$siteId/integrations'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdIntegrationsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/events/': {
      id: '/_layout/dashboard/sites/$siteId/events/'
      path: '/dashboard/sites/$siteId/events'
      fullPath: '/dashboard/sites/$siteId/events'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdEventsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/daily-pricing/': {
      id: '/_layout/dashboard/sites/$siteId/daily-pricing/'
      path: '/dashboard/sites/$siteId/daily-pricing'
      fullPath: '/dashboard/sites/$siteId/daily-pricing'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdDailyPricingIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/activities-and-products/': {
      id: '/_layout/dashboard/sites/$siteId/activities-and-products/'
      path: '/dashboard/sites/$siteId/activities-and-products'
      fullPath: '/dashboard/sites/$siteId/activities-and-products'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sales-agents/$agentId/edit/': {
      id: '/_layout/dashboard/sales-agents/$agentId/edit/'
      path: '/dashboard/sales-agents/$agentId/edit'
      fullPath: '/dashboard/sales-agents/$agentId/edit'
      preLoaderRoute: typeof LayoutDashboardSalesAgentsAgentIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/resellers/$resellerId/edit/': {
      id: '/_layout/dashboard/resellers/$resellerId/edit/'
      path: '/dashboard/resellers/$resellerId/edit'
      fullPath: '/dashboard/resellers/$resellerId/edit'
      preLoaderRoute: typeof LayoutDashboardResellersResellerIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/organizations/$organizationId/edit/': {
      id: '/_layout/dashboard/organizations/$organizationId/edit/'
      path: '/dashboard/organizations/$organizationId/edit'
      fullPath: '/dashboard/organizations/$organizationId/edit'
      preLoaderRoute: typeof LayoutDashboardOrganizationsOrganizationIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/quick-answers/update-branding/': {
      id: '/_layout/dashboard/help-and-support/quick-answers/update-branding/'
      path: '/dashboard/help-and-support/quick-answers/update-branding'
      fullPath: '/dashboard/help-and-support/quick-answers/update-branding'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/quick-answers/shift4-guide/': {
      id: '/_layout/dashboard/help-and-support/quick-answers/shift4-guide/'
      path: '/dashboard/help-and-support/quick-answers/shift4-guide'
      fullPath: '/dashboard/help-and-support/quick-answers/shift4-guide'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/quick-answers/quickbook-integration/': {
      id: '/_layout/dashboard/help-and-support/quick-answers/quickbook-integration/'
      path: '/dashboard/help-and-support/quick-answers/quickbook-integration'
      fullPath: '/dashboard/help-and-support/quick-answers/quickbook-integration'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/quick-answers/mews-rates/': {
      id: '/_layout/dashboard/help-and-support/quick-answers/mews-rates/'
      path: '/dashboard/help-and-support/quick-answers/mews-rates'
      fullPath: '/dashboard/help-and-support/quick-answers/mews-rates'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/quick-answers/mews-packages/': {
      id: '/_layout/dashboard/help-and-support/quick-answers/mews-packages/'
      path: '/dashboard/help-and-support/quick-answers/mews-packages'
      fullPath: '/dashboard/help-and-support/quick-answers/mews-packages'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/quick-answers/gtm-guide/': {
      id: '/_layout/dashboard/help-and-support/quick-answers/gtm-guide/'
      path: '/dashboard/help-and-support/quick-answers/gtm-guide'
      fullPath: '/dashboard/help-and-support/quick-answers/gtm-guide'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/help-and-support/quick-answers/ga4-guide/': {
      id: '/_layout/dashboard/help-and-support/quick-answers/ga4-guide/'
      path: '/dashboard/help-and-support/quick-answers/ga4-guide'
      fullPath: '/dashboard/help-and-support/quick-answers/ga4-guide'
      preLoaderRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/group/$groupId/performance/': {
      id: '/_layout/dashboard/group/$groupId/performance/'
      path: '/dashboard/group/$groupId/performance'
      fullPath: '/dashboard/group/$groupId/performance'
      preLoaderRoute: typeof LayoutDashboardGroupGroupIdPerformanceIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/group/$groupId/edit-group/': {
      id: '/_layout/dashboard/group/$groupId/edit-group/'
      path: '/dashboard/group/$groupId/edit-group'
      fullPath: '/dashboard/group/$groupId/edit-group'
      preLoaderRoute: typeof LayoutDashboardGroupGroupIdEditGroupIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/group/$groupId/commissions/': {
      id: '/_layout/dashboard/group/$groupId/commissions/'
      path: '/dashboard/group/$groupId/commissions'
      fullPath: '/dashboard/group/$groupId/commissions'
      preLoaderRoute: typeof LayoutDashboardGroupGroupIdCommissionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/collection/$collectionId/edit/': {
      id: '/_layout/dashboard/collection/$collectionId/edit/'
      path: '/dashboard/collection/$collectionId/edit'
      fullPath: '/dashboard/collection/$collectionId/edit'
      preLoaderRoute: typeof LayoutDashboardCollectionCollectionIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/blog/$blogId/edit/': {
      id: '/_layout/dashboard/blog/$blogId/edit/'
      path: '/dashboard/blog/$blogId/edit'
      fullPath: '/dashboard/blog/$blogId/edit'
      preLoaderRoute: typeof LayoutDashboardBlogBlogIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/site-customization/policies/': {
      id: '/_layout/dashboard/sites/$siteId/site-customization/policies/'
      path: '/dashboard/sites/$siteId/site-customization/policies'
      fullPath: '/dashboard/sites/$siteId/site-customization/policies'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/site-customization/emails/': {
      id: '/_layout/dashboard/sites/$siteId/site-customization/emails/'
      path: '/dashboard/sites/$siteId/site-customization/emails'
      fullPath: '/dashboard/sites/$siteId/site-customization/emails'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rooms/create/': {
      id: '/_layout/dashboard/sites/$siteId/rooms/create/'
      path: '/dashboard/sites/$siteId/rooms/create'
      fullPath: '/dashboard/sites/$siteId/rooms/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomsCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rooms/add-ons/': {
      id: '/_layout/dashboard/sites/$siteId/rooms/add-ons/'
      path: '/dashboard/sites/$siteId/rooms/add-ons'
      fullPath: '/dashboard/sites/$siteId/rooms/add-ons'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomsAddOnsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/room-blocks/create/': {
      id: '/_layout/dashboard/sites/$siteId/room-blocks/create/'
      path: '/dashboard/sites/$siteId/room-blocks/create'
      fullPath: '/dashboard/sites/$siteId/room-blocks/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/': {
      id: '/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/'
      path: '/dashboard/sites/$siteId/room-blocks/$roomBlockId'
      fullPath: '/dashboard/sites/$siteId/room-blocks/$roomBlockId'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/restrictions/create/': {
      id: '/_layout/dashboard/sites/$siteId/restrictions/create/'
      path: '/dashboard/sites/$siteId/restrictions/create'
      fullPath: '/dashboard/sites/$siteId/restrictions/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRestrictionsCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/reservations/waitlist/': {
      id: '/_layout/dashboard/sites/$siteId/reservations/waitlist/'
      path: '/dashboard/sites/$siteId/reservations/waitlist'
      fullPath: '/dashboard/sites/$siteId/reservations/waitlist'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdReservationsWaitlistIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/reservations/$purchaseId/': {
      id: '/_layout/dashboard/sites/$siteId/reservations/$purchaseId/'
      path: '/dashboard/sites/$siteId/reservations/$purchaseId'
      fullPath: '/dashboard/sites/$siteId/reservations/$purchaseId'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/'
      path: '/dashboard/sites/$siteId/rates-and-packages/rates'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/rates'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/'
      path: '/dashboard/sites/$siteId/rates-and-packages/promo-code'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/promo-code'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/'
      path: '/dashboard/sites/$siteId/rates-and-packages/packages'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/packages'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/inventories/property-restrictions/': {
      id: '/_layout/dashboard/sites/$siteId/inventories/property-restrictions/'
      path: '/dashboard/sites/$siteId/inventories/property-restrictions'
      fullPath: '/dashboard/sites/$siteId/inventories/property-restrictions'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/events/create/': {
      id: '/_layout/dashboard/sites/$siteId/events/create/'
      path: '/dashboard/sites/$siteId/events/create'
      fullPath: '/dashboard/sites/$siteId/events/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdEventsCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/events/$eventId/': {
      id: '/_layout/dashboard/sites/$siteId/events/$eventId/'
      path: '/dashboard/sites/$siteId/events/$eventId'
      fullPath: '/dashboard/sites/$siteId/events/$eventId'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdEventsEventIdIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/activities-and-products/create/': {
      id: '/_layout/dashboard/sites/$siteId/activities-and-products/create/'
      path: '/dashboard/sites/$siteId/activities-and-products/create'
      fullPath: '/dashboard/sites/$siteId/activities-and-products/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rooms/add-ons/create/': {
      id: '/_layout/dashboard/sites/$siteId/rooms/add-ons/create/'
      path: '/dashboard/sites/$siteId/rooms/add-ons/create'
      fullPath: '/dashboard/sites/$siteId/rooms/add-ons/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rooms/$roomId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/rooms/$roomId/edit/'
      path: '/dashboard/sites/$siteId/rooms/$roomId/edit'
      fullPath: '/dashboard/sites/$siteId/rooms/$roomId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit/'
      path: '/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit'
      fullPath: '/dashboard/sites/$siteId/room-blocks/$roomBlockId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/restrictions/$restrictionId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/restrictions/$restrictionId/edit/'
      path: '/dashboard/sites/$siteId/restrictions/$restrictionId/edit'
      fullPath: '/dashboard/sites/$siteId/restrictions/$restrictionId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create/'
      path: '/dashboard/sites/$siteId/rates-and-packages/rates/create'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/rates/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/'
      path: '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group/'
      path: '/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/rateGroups/create-rate-group'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/create/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/create/'
      path: '/dashboard/sites/$siteId/rates-and-packages/promo-code/create'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/promo-code/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/create/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/create/'
      path: '/dashboard/sites/$siteId/rates-and-packages/packages/create'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/packages/create'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/events/$eventId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/events/$eventId/edit/'
      path: '/dashboard/sites/$siteId/events/$eventId/edit'
      fullPath: '/dashboard/sites/$siteId/events/$eventId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdEventsEventIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/activities-and-products/$activityId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/activities-and-products/$activityId/edit/'
      path: '/dashboard/sites/$siteId/activities-and-products/$activityId/edit'
      fullPath: '/dashboard/sites/$siteId/activities-and-products/$activityId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/': {
      id: '/_layout/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/'
      path: '/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy'
      fullPath: '/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy/': {
      id: '/_layout/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy/'
      path: '/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy'
      fullPath: '/dashboard/sites/$siteId/site-customization/policies/create/cancelation-policy'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit/'
      path: '/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit'
      fullPath: '/dashboard/sites/$siteId/rooms/add-ons/$addonId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit/'
      path: '/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/rates/$rateId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit/'
      path: '/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/rateGroups/$rateGroupId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit/'
      path: '/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/promo-code/$promoCodeId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit/'
      path: '/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/packages/$packageId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit/'
      path: '/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit'
      fullPath: '/dashboard/sites/$siteId/site-customization/policies/tax-and-fees/$policyId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit/'
      path: '/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit'
      fullPath: '/dashboard/sites/$siteId/site-customization/policies/cancellations/$policyId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/': {
      id: '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/'
      path: '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit'
      fullPath: '/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit'
      preLoaderRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  LayoutDashboardIndexRoute: typeof LayoutDashboardIndexRoute
  LayoutDashboardAccountSettingsIndexRoute: typeof LayoutDashboardAccountSettingsIndexRoute
  LayoutDashboardBlogIndexRoute: typeof LayoutDashboardBlogIndexRoute
  LayoutDashboardCommissionsIndexRoute: typeof LayoutDashboardCommissionsIndexRoute
  LayoutDashboardGeneralIndexRoute: typeof LayoutDashboardGeneralIndexRoute
  LayoutDashboardHelpAndSupportIndexRoute: typeof LayoutDashboardHelpAndSupportIndexRoute
  LayoutDashboardHelpIndexRoute: typeof LayoutDashboardHelpIndexRoute
  LayoutDashboardOrganizationsIndexRoute: typeof LayoutDashboardOrganizationsIndexRoute
  LayoutDashboardResellersIndexRoute: typeof LayoutDashboardResellersIndexRoute
  LayoutDashboardSalesAgentsIndexRoute: typeof LayoutDashboardSalesAgentsIndexRoute
  LayoutDashboardSitesIndexRoute: typeof LayoutDashboardSitesIndexRoute
  LayoutDashboardUsersIndexRoute: typeof LayoutDashboardUsersIndexRoute
  LayoutDashboardBlogBlogIdIndexRoute: typeof LayoutDashboardBlogBlogIdIndexRoute
  LayoutDashboardBlogCreateIndexRoute: typeof LayoutDashboardBlogCreateIndexRoute
  LayoutDashboardCommissionsConfigHistoryIndexRoute: typeof LayoutDashboardCommissionsConfigHistoryIndexRoute
  LayoutDashboardCommissionsPaymentHistoryIndexRoute: typeof LayoutDashboardCommissionsPaymentHistoryIndexRoute
  LayoutDashboardCommissionsPayoutsReportIndexRoute: typeof LayoutDashboardCommissionsPayoutsReportIndexRoute
  LayoutDashboardHelpAndSupportContactFormIndexRoute: typeof LayoutDashboardHelpAndSupportContactFormIndexRoute
  LayoutDashboardOrganizationsCreateIndexRoute: typeof LayoutDashboardOrganizationsCreateIndexRoute
  LayoutDashboardResellersResellerIdIndexRoute: typeof LayoutDashboardResellersResellerIdIndexRoute
  LayoutDashboardResellersCreateIndexRoute: typeof LayoutDashboardResellersCreateIndexRoute
  LayoutDashboardSalesAgentsCreateIndexRoute: typeof LayoutDashboardSalesAgentsCreateIndexRoute
  LayoutDashboardSitesSiteIdIndexRoute: typeof LayoutDashboardSitesSiteIdIndexRoute
  LayoutDashboardSitesCreateCollectionIndexRoute: typeof LayoutDashboardSitesCreateCollectionIndexRoute
  LayoutDashboardSitesCreateGroupSiteIndexRoute: typeof LayoutDashboardSitesCreateGroupSiteIndexRoute
  LayoutDashboardSitesCreateGroupIndexRoute: typeof LayoutDashboardSitesCreateGroupIndexRoute
  LayoutDashboardSitesCreateIndexRoute: typeof LayoutDashboardSitesCreateIndexRoute
  LayoutDashboardUsersUserIdIndexRoute: typeof LayoutDashboardUsersUserIdIndexRoute
  LayoutDashboardUsersCreateUserIndexRoute: typeof LayoutDashboardUsersCreateUserIndexRoute
  LayoutDashboardBlogBlogIdEditIndexRoute: typeof LayoutDashboardBlogBlogIdEditIndexRoute
  LayoutDashboardCollectionCollectionIdEditIndexRoute: typeof LayoutDashboardCollectionCollectionIdEditIndexRoute
  LayoutDashboardGroupGroupIdCommissionsIndexRoute: typeof LayoutDashboardGroupGroupIdCommissionsIndexRoute
  LayoutDashboardGroupGroupIdEditGroupIndexRoute: typeof LayoutDashboardGroupGroupIdEditGroupIndexRoute
  LayoutDashboardGroupGroupIdPerformanceIndexRoute: typeof LayoutDashboardGroupGroupIdPerformanceIndexRoute
  LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRoute
  LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRoute
  LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRoute
  LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRoute
  LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRoute
  LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRoute
  LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRoute: typeof LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRoute
  LayoutDashboardOrganizationsOrganizationIdEditIndexRoute: typeof LayoutDashboardOrganizationsOrganizationIdEditIndexRoute
  LayoutDashboardResellersResellerIdEditIndexRoute: typeof LayoutDashboardResellersResellerIdEditIndexRoute
  LayoutDashboardSalesAgentsAgentIdEditIndexRoute: typeof LayoutDashboardSalesAgentsAgentIdEditIndexRoute
  LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRoute: typeof LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRoute
  LayoutDashboardSitesSiteIdDailyPricingIndexRoute: typeof LayoutDashboardSitesSiteIdDailyPricingIndexRoute
  LayoutDashboardSitesSiteIdEventsIndexRoute: typeof LayoutDashboardSitesSiteIdEventsIndexRoute
  LayoutDashboardSitesSiteIdIntegrationsIndexRoute: typeof LayoutDashboardSitesSiteIdIntegrationsIndexRoute
  LayoutDashboardSitesSiteIdInventoriesIndexRoute: typeof LayoutDashboardSitesSiteIdInventoriesIndexRoute
  LayoutDashboardSitesSiteIdReservationsIndexRoute: typeof LayoutDashboardSitesSiteIdReservationsIndexRoute
  LayoutDashboardSitesSiteIdRestrictionsIndexRoute: typeof LayoutDashboardSitesSiteIdRestrictionsIndexRoute
  LayoutDashboardSitesSiteIdRoomBlocksIndexRoute: typeof LayoutDashboardSitesSiteIdRoomBlocksIndexRoute
  LayoutDashboardSitesSiteIdRoomsIndexRoute: typeof LayoutDashboardSitesSiteIdRoomsIndexRoute
  LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRoute: typeof LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRoute
  LayoutDashboardSitesSiteIdServiceBlocksIndexRoute: typeof LayoutDashboardSitesSiteIdServiceBlocksIndexRoute
  LayoutDashboardSitesSiteIdSiteCustomizationIndexRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationIndexRoute
  LayoutDashboardUsersUserIdEditIndexRoute: typeof LayoutDashboardUsersUserIdEditIndexRoute
  LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRoute: typeof LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRoute
  LayoutDashboardSitesSiteIdEventsEventIdIndexRoute: typeof LayoutDashboardSitesSiteIdEventsEventIdIndexRoute
  LayoutDashboardSitesSiteIdEventsCreateIndexRoute: typeof LayoutDashboardSitesSiteIdEventsCreateIndexRoute
  LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRoute: typeof LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRoute
  LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRoute: typeof LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRoute
  LayoutDashboardSitesSiteIdReservationsWaitlistIndexRoute: typeof LayoutDashboardSitesSiteIdReservationsWaitlistIndexRoute
  LayoutDashboardSitesSiteIdRestrictionsCreateIndexRoute: typeof LayoutDashboardSitesSiteIdRestrictionsCreateIndexRoute
  LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRoute: typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRoute
  LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRoute: typeof LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRoute
  LayoutDashboardSitesSiteIdRoomsAddOnsIndexRoute: typeof LayoutDashboardSitesSiteIdRoomsAddOnsIndexRoute
  LayoutDashboardSitesSiteIdRoomsCreateIndexRoute: typeof LayoutDashboardSitesSiteIdRoomsCreateIndexRoute
  LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRoute
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRoute
  LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRoute
  LayoutDashboardSitesSiteIdEventsEventIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdEventsEventIdEditIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRoute
  LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRoute
  LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRoute
  LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRoute
  LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRoute: typeof LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRoute
  LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRoute
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRoute
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRoute
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRoute
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRoute
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRoute: typeof LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutDashboardIndexRoute: LayoutDashboardIndexRoute,
  LayoutDashboardAccountSettingsIndexRoute:
    LayoutDashboardAccountSettingsIndexRoute,
  LayoutDashboardBlogIndexRoute: LayoutDashboardBlogIndexRoute,
  LayoutDashboardCommissionsIndexRoute: LayoutDashboardCommissionsIndexRoute,
  LayoutDashboardGeneralIndexRoute: LayoutDashboardGeneralIndexRoute,
  LayoutDashboardHelpAndSupportIndexRoute:
    LayoutDashboardHelpAndSupportIndexRoute,
  LayoutDashboardHelpIndexRoute: LayoutDashboardHelpIndexRoute,
  LayoutDashboardOrganizationsIndexRoute:
    LayoutDashboardOrganizationsIndexRoute,
  LayoutDashboardResellersIndexRoute: LayoutDashboardResellersIndexRoute,
  LayoutDashboardSalesAgentsIndexRoute: LayoutDashboardSalesAgentsIndexRoute,
  LayoutDashboardSitesIndexRoute: LayoutDashboardSitesIndexRoute,
  LayoutDashboardUsersIndexRoute: LayoutDashboardUsersIndexRoute,
  LayoutDashboardBlogBlogIdIndexRoute: LayoutDashboardBlogBlogIdIndexRoute,
  LayoutDashboardBlogCreateIndexRoute: LayoutDashboardBlogCreateIndexRoute,
  LayoutDashboardCommissionsConfigHistoryIndexRoute:
    LayoutDashboardCommissionsConfigHistoryIndexRoute,
  LayoutDashboardCommissionsPaymentHistoryIndexRoute:
    LayoutDashboardCommissionsPaymentHistoryIndexRoute,
  LayoutDashboardCommissionsPayoutsReportIndexRoute:
    LayoutDashboardCommissionsPayoutsReportIndexRoute,
  LayoutDashboardHelpAndSupportContactFormIndexRoute:
    LayoutDashboardHelpAndSupportContactFormIndexRoute,
  LayoutDashboardOrganizationsCreateIndexRoute:
    LayoutDashboardOrganizationsCreateIndexRoute,
  LayoutDashboardResellersResellerIdIndexRoute:
    LayoutDashboardResellersResellerIdIndexRoute,
  LayoutDashboardResellersCreateIndexRoute:
    LayoutDashboardResellersCreateIndexRoute,
  LayoutDashboardSalesAgentsCreateIndexRoute:
    LayoutDashboardSalesAgentsCreateIndexRoute,
  LayoutDashboardSitesSiteIdIndexRoute: LayoutDashboardSitesSiteIdIndexRoute,
  LayoutDashboardSitesCreateCollectionIndexRoute:
    LayoutDashboardSitesCreateCollectionIndexRoute,
  LayoutDashboardSitesCreateGroupSiteIndexRoute:
    LayoutDashboardSitesCreateGroupSiteIndexRoute,
  LayoutDashboardSitesCreateGroupIndexRoute:
    LayoutDashboardSitesCreateGroupIndexRoute,
  LayoutDashboardSitesCreateIndexRoute: LayoutDashboardSitesCreateIndexRoute,
  LayoutDashboardUsersUserIdIndexRoute: LayoutDashboardUsersUserIdIndexRoute,
  LayoutDashboardUsersCreateUserIndexRoute:
    LayoutDashboardUsersCreateUserIndexRoute,
  LayoutDashboardBlogBlogIdEditIndexRoute:
    LayoutDashboardBlogBlogIdEditIndexRoute,
  LayoutDashboardCollectionCollectionIdEditIndexRoute:
    LayoutDashboardCollectionCollectionIdEditIndexRoute,
  LayoutDashboardGroupGroupIdCommissionsIndexRoute:
    LayoutDashboardGroupGroupIdCommissionsIndexRoute,
  LayoutDashboardGroupGroupIdEditGroupIndexRoute:
    LayoutDashboardGroupGroupIdEditGroupIndexRoute,
  LayoutDashboardGroupGroupIdPerformanceIndexRoute:
    LayoutDashboardGroupGroupIdPerformanceIndexRoute,
  LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRoute:
    LayoutDashboardHelpAndSupportQuickAnswersGa4GuideIndexRoute,
  LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRoute:
    LayoutDashboardHelpAndSupportQuickAnswersGtmGuideIndexRoute,
  LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRoute:
    LayoutDashboardHelpAndSupportQuickAnswersMewsPackagesIndexRoute,
  LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRoute:
    LayoutDashboardHelpAndSupportQuickAnswersMewsRatesIndexRoute,
  LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRoute:
    LayoutDashboardHelpAndSupportQuickAnswersQuickbookIntegrationIndexRoute,
  LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRoute:
    LayoutDashboardHelpAndSupportQuickAnswersShift4GuideIndexRoute,
  LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRoute:
    LayoutDashboardHelpAndSupportQuickAnswersUpdateBrandingIndexRoute,
  LayoutDashboardOrganizationsOrganizationIdEditIndexRoute:
    LayoutDashboardOrganizationsOrganizationIdEditIndexRoute,
  LayoutDashboardResellersResellerIdEditIndexRoute:
    LayoutDashboardResellersResellerIdEditIndexRoute,
  LayoutDashboardSalesAgentsAgentIdEditIndexRoute:
    LayoutDashboardSalesAgentsAgentIdEditIndexRoute,
  LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRoute:
    LayoutDashboardSitesSiteIdActivitiesAndProductsIndexRoute,
  LayoutDashboardSitesSiteIdDailyPricingIndexRoute:
    LayoutDashboardSitesSiteIdDailyPricingIndexRoute,
  LayoutDashboardSitesSiteIdEventsIndexRoute:
    LayoutDashboardSitesSiteIdEventsIndexRoute,
  LayoutDashboardSitesSiteIdIntegrationsIndexRoute:
    LayoutDashboardSitesSiteIdIntegrationsIndexRoute,
  LayoutDashboardSitesSiteIdInventoriesIndexRoute:
    LayoutDashboardSitesSiteIdInventoriesIndexRoute,
  LayoutDashboardSitesSiteIdReservationsIndexRoute:
    LayoutDashboardSitesSiteIdReservationsIndexRoute,
  LayoutDashboardSitesSiteIdRestrictionsIndexRoute:
    LayoutDashboardSitesSiteIdRestrictionsIndexRoute,
  LayoutDashboardSitesSiteIdRoomBlocksIndexRoute:
    LayoutDashboardSitesSiteIdRoomBlocksIndexRoute,
  LayoutDashboardSitesSiteIdRoomsIndexRoute:
    LayoutDashboardSitesSiteIdRoomsIndexRoute,
  LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRoute:
    LayoutDashboardSitesSiteIdSeasonalCancellationPoliciesIndexRoute,
  LayoutDashboardSitesSiteIdServiceBlocksIndexRoute:
    LayoutDashboardSitesSiteIdServiceBlocksIndexRoute,
  LayoutDashboardSitesSiteIdSiteCustomizationIndexRoute:
    LayoutDashboardSitesSiteIdSiteCustomizationIndexRoute,
  LayoutDashboardUsersUserIdEditIndexRoute:
    LayoutDashboardUsersUserIdEditIndexRoute,
  LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRoute:
    LayoutDashboardSitesSiteIdActivitiesAndProductsCreateIndexRoute,
  LayoutDashboardSitesSiteIdEventsEventIdIndexRoute:
    LayoutDashboardSitesSiteIdEventsEventIdIndexRoute,
  LayoutDashboardSitesSiteIdEventsCreateIndexRoute:
    LayoutDashboardSitesSiteIdEventsCreateIndexRoute,
  LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRoute:
    LayoutDashboardSitesSiteIdInventoriesPropertyRestrictionsIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesPackagesIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesRatesIndexRoute,
  LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRoute:
    LayoutDashboardSitesSiteIdReservationsPurchaseIdIndexRoute,
  LayoutDashboardSitesSiteIdReservationsWaitlistIndexRoute:
    LayoutDashboardSitesSiteIdReservationsWaitlistIndexRoute,
  LayoutDashboardSitesSiteIdRestrictionsCreateIndexRoute:
    LayoutDashboardSitesSiteIdRestrictionsCreateIndexRoute,
  LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRoute:
    LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdIndexRoute,
  LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRoute:
    LayoutDashboardSitesSiteIdRoomBlocksCreateIndexRoute,
  LayoutDashboardSitesSiteIdRoomsAddOnsIndexRoute:
    LayoutDashboardSitesSiteIdRoomsAddOnsIndexRoute,
  LayoutDashboardSitesSiteIdRoomsCreateIndexRoute:
    LayoutDashboardSitesSiteIdRoomsCreateIndexRoute,
  LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRoute:
    LayoutDashboardSitesSiteIdSiteCustomizationEmailsIndexRoute,
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRoute:
    LayoutDashboardSitesSiteIdSiteCustomizationPoliciesIndexRoute,
  LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRoute:
    LayoutDashboardSitesSiteIdActivitiesAndProductsActivityIdEditIndexRoute,
  LayoutDashboardSitesSiteIdEventsEventIdEditIndexRoute:
    LayoutDashboardSitesSiteIdEventsEventIdEditIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesPackagesCreateIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodeCreateIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsCreateRateGroupIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateIndexRoute,
  LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRestrictionsRestrictionIdEditIndexRoute,
  LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRoomBlocksRoomBlockIdEditIndexRoute,
  LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRoomsRoomIdEditIndexRoute,
  LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRoute:
    LayoutDashboardSitesSiteIdRoomsAddOnsCreateIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesPackagesPackageIdEditIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesPromoCodePromoCodeIdEditIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesRateGroupsRateGroupIdEditIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesRatesRateIdEditIndexRoute,
  LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRoomsAddOnsAddonIdEditIndexRoute,
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRoute:
    LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateCancelationPolicyIndexRoute,
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRoute:
    LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCreateTaxAndFeesPolicyIndexRoute,
  LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRoute:
    LayoutDashboardSitesSiteIdRatesAndPackagesRatesCreateLinkedRateLinkedRateIdEditIndexRoute,
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRoute:
    LayoutDashboardSitesSiteIdSiteCustomizationPoliciesCancellationsPolicyIdEditIndexRoute,
  LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRoute:
    LayoutDashboardSitesSiteIdSiteCustomizationPoliciesTaxAndFeesPolicyIdEditIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LayoutRoute: LayoutRouteWithChildren,
  ForgotPasswordLazyRoute: ForgotPasswordLazyRoute,
  ResetPasswordTokenIndexLazyRoute: ResetPasswordTokenIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
